import PropTypes from "prop-types";
import {
  FaTimes,
  FaUpload,
  FaFile,
  FaFilePdf,
  FaFileWord,
  FaFileExcel,
  FaDownload,
  FaClipboardList,
  FaTools,
  FaListUl,
  FaPaperclip,
} from "react-icons/fa";

import React, { useEffect, useRef, useState } from "react";
import { toast } from "react-toastify";
import InputField from "../../SharedComponent/Fields/InputField";
import TextAreaField from "../../SharedComponent/Fields/TextareaField";
import SelectField from "../../SharedComponent/Fields/SelectField";
import Button from "../../SharedComponent/Button/Button";
import { API_END_POINTS } from "../../network/apiEndPoint";
import { getProtected, postProtected } from "../../network/ApiService";
import { useTranslation } from "react-i18next";
import axios from "axios";
import Stepper from "./Stepper/Stepper";
import { useLocation, useNavigate } from "react-router-dom";
import { normalizeYearOfManufacture } from "../../utils/yearOfManufacture";
import { showApiErrorToasts } from "../../utils/apiErrorUtils";
import { ImagePlus, KeySquare, Upload, X } from "lucide-react";
import HeroSection from "../HeroSection/HeroSection";
import { baseURL, baseURlNoAPI } from "../../network/baseUrl";
import ContractHistoryTable from "../ContractHistoryTable";
import Batteries from "../assets_type/Batteries";
import BookValueHistory from "./BookValueHistory";
import Chargers from "../assets_type/Chargers";
import i18next, { t } from "i18next";
import Attachments from "../assets_type/Attachments";
import FinancialInfoSection from "../assets_type/FinancialInfoSection";
import ContractInfoSection from "../assets_type/ContractInfoSection";
import LiftMasts from "../assets_type/LiftMasts";
import WorkPlatforms from "../assets_type/WorkPlateform";
import CleaningEquipment from "../assets_type/CleaningEquipments";
import SpareParts from "../assets_type/SpareParts";
import ConstructionMachinery from "../assets_type/ConstructionMachinery";
import AssetFormButtonGroup from "../assets_type/AssetFormButtonGroup";

const initialAssets = {
  documents: [],
  platform: "",
  visible: true,
  insertDate: "",
  id: null,
  machineIdDealer: "",
  idUrl: "",
  manufacturer: "",
  type: "",
  yearOfManufacture: "",
  operatingHours: "",
  machineSerialNo: "",
  classification: "",
  forkliftClass: "",
  antriebsart: "",
  machineDescriptionTitle: "",
  machineDescriptionSubtitle: "",
  machineDescriptionTemp: "",
  machineAvailable: true,
  truckLocation: "",
  salesmen: [],
  priceType: "",
  techCondition: "",
  reconditioningDate: "",
  offerNoDealer: "",
  offerNoPlatform: "",
  machineLength: "",
  machineWidth: "",
  machineHeight: "",
  basketLoad: "",
  reachHorizontal: "",
  machineWeight: "",
  closedHeight: "",
  freeHeight: "",
  forkCarriage: "",
  forkLength: "",
  loadCentre: "",
  tiresFront: "",
  tiresFront_size: "",
  tiresRear: "",
  tiresRear_size: "",
  twinTires: false,
  addEquipment: [],
  mediaFiles: [],
};

const latestInitialAssets = {
  // Truck basic fields
  use_invoice_as_delivery: false,
  asset_type: "Forklifts",
  platform: "",
  visible: "",
  liftmast_classification: "",
  manufacturer: "",
  intern_no: "",
  additional_equipment: [],
  year_of_manufacture: "",
  operating_hours: "",
  serial_no: "",
  capacity: "",
  mast_type: 0,
  lift_height_mm: "",
  status: "",
  classification: "",
  fem_class: "",
  engine_type: "",
  condition: "",
  title: "",
  description: "",
  description_temp: "",
  available: false,
  location: "",
  salesmen: "",
  currency: "",
  price: "",
  price_netto: "",
  // dealer_price: "",
  price_description: "",
  rental_price_per_day: "",
  rental_price_per_week: "",
  rental_price_per_month: "",
  rental_price_description: "",
  // dealer_id:"",
  // detail_url:"",

  // Truck Description fields

  type: "",
  // media_files:[],
  // price_usd:"",
  // price_netto_usd:"",
  // rental_price_per_day:"",
  // rental_price:"",
  technical_condition: "",
  optical_condition: "",
  machine_length_mm: "",
  machine_width_mm: "",
  machine_height_mm: "",
  machine_weight_kg: "",
  basket_load: "",
  reach_horizontal: "",
  reconditioning_date: "",
  battery: false,
  battery_voltage: "",
  battery_capacity: "",
  battery_case: "",
  battery_category: "",
  battery_charger: true,
  battery_charger_type: "",
  offer_no_dealer: "",
  offer_no_platform: "",
  closed_height_mm: "",
  freihub: false,
  fork_carr: "",
  free_height: "",
  fork_length: "",
  forks: "",
  load_centre: 0,
  tire_type: "",
  front_tire_size: "",
  rear_tires: "",
  rear_tire_size: "",
  front_tires: "",

  working_height: "",
  battery_additional_equipment: "",

  // Dealer Information

  dealer_name: "",
  dealer_status: "",
  dealer_contact_information: "",
  dealer_location: "",
  dealer_price: "",
  dealer_price_netto: "",
  dealer_country: "",
  dealer_city: "",
  dealer_zip: "",
  dealer_street: "",
  dealer_contact_person: "",
  dealer_address: "",
  dealer_phone: "",
  dealer_website: "",
  dealer_email: "",

  // Finance Information
  finance_partner: "",
  financial_contract_classification: "",
  financial_contract: "",
  financial_contract_no: "",
  upload_financial_contract: "",
  financial_contract_start: "",
  financial_contract_end: "",
  duration_in_months: "",
  purchase_price: "",
  acquisition_date: "",
  residual_value_end_of_contract: "",
  book_value: "",
  depreciation_value: "",
  acquisition_costs: "",
  depreciation_method: "",
  next_depreciation: "",
  cost_refurbishing: "",
  transportation_cost: "",
  customer_name: "",
  customer_no: "",
  customer_contract: "",
  upload_customer_contract: null,
  end_of_contract: null,
  contract_completed: false,

  // battery information
  battery_manufacturer: "",
  battery_type: "",
  chargerLoadertype: "",
  cleaning_toc: "",
  sparetype: "",
  batterymodel: "",
  battery_voltage: "",
  batterycapacity: "",
  batteryACVoltage: "",
  attachment_toc: "",
  workplatform_toc: "",
  mast_type: "",

  battery_yom: "",
  batteryAdditionalEquipment: "",
  batterylength: "",
  batterywidth: "",
  batteryweight: "",
  batteryCasing: "",
  battery_location: "",
  battery_description: "",
  batterycapacity: "",
  battery_length: "",
  additional_equipment_description: "",
  batteryheight: "",

  //charger specifications

  chargerManufacturer: "",
  chargerLoadertype: "",
  chargerModel: "",
  chargerAC: "",
  chargerCurrent: "",
  chargerVoltage: "",
  charger_yom: "",
  chargerAdditionalEquipment: "",
  chargerLocation: "",

  mast_description: "",

  forks_description: "",
  tire_description: "",
  fork_carriage_description: "",

  // second tab fields
  end_user_price: "",
  internal_price: "",
  intranet_price: "",
  dealer_price: "",
  rental_price_daily: "",
  rental_price_weekly: "",
  rental_price_monthly: "",
  internal_remark: "",
  intranet_remark: "",
  purchase_price: "",
  purchase_date: "",
  book_value: "",

  // 3rd tab fields
  customer_name: "",
  customer_company_name: "",
  customer_phone: "",
  customer_no: "",
  contract_type: "",
  contract_price_euro: "",
  contract_start: "",
  contract_end: "",
  customer_location_zip: "",
  customer_location_city: "",
  customer_location_country: "",
  customer_contact_name: "",
  customer_email: "",
  customer_number: "",
  invoice_address_street: "",
  invoice_address_zip: "",
  invoice_address_city: "",
  invoice_address_country: "",

  contracts: [
    {
      customer: {
        name: "",
        phone_number: "",
        email: "",
        customer_company: "",
        customer_number: "",
      },
      contract_type: "",
      contract_start: "",
      contract_end: "",
      contract_price_euro: "",
      invoice_address_street: "",
      invoice_address_zip: "",
      invoice_address_city: "",
      invoice_address_country: "",

      delivery_address_street: "",
      delivery_address_zip: "",
      delivery_address_city: "",
      delivery_address_country: "",
    },
  ],
};

const getFileInfo = (url) => {
  const extension = url.split(".").pop().toLowerCase();
  const fileTypes = {
    pdf: {
      type: "application/pdf",
      icon: <FaFilePdf size={20} className="text-danger" />,
    },
    xlsx: {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      icon: <FaFileExcel size={20} className="text-success" />,
    },
    xls: {
      type: "application/vnd.ms-excel",
      icon: <FaFileExcel size={20} className="text-success" />,
    },
    doc: {
      type: "application/msword",
      icon: <FaFileWord size={20} className="text-primary" />,
    },
    docx: {
      type: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      icon: <FaFileWord size={20} className="text-primary" />,
    },
  };
  return (
    fileTypes[extension] || {
      type: "application/octet-stream",
      icon: <FaFile size={20} />,
    }
  );
};

const handleDownload = async (url, filename) => {
  try {
    const response = await fetch(url, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });

    if (!response.ok) throw new Error("Download failed");

    const blob = await response.blob();
    const fileInfo = getFileInfo(url);
    const blobWithType = new Blob([blob], { type: fileInfo.type });

    const downloadUrl = window.URL.createObjectURL(blobWithType);
    const link = document.createElement("a");
    link.href = downloadUrl;
    link.download = filename || url.split("/").pop();
    document.body.appendChild(link);
    link.click();

    document.body.removeChild(link);
    window.URL.revokeObjectURL(downloadUrl);
  } catch (error) {
    console.error("Download error:", error);
    toast.error("Failed to download file");
  }
};

const AttachmentLink = ({ url, children }) => {
  const filename = url.split("/").pop();
  const fileInfo = getFileInfo(url);
  const [clickTimeout, setClickTimeout] = useState(null);

  const handleClick = (e) => {
    e.preventDefault();

    if (clickTimeout === null) {
      setClickTimeout(
        setTimeout(() => {
          window.open(url, "_blank");
          setClickTimeout(null);
        }, 300)
      );
    } else {
      clearTimeout(clickTimeout);
      setClickTimeout(null);
      handleDownload(url, filename);
    }
  };

  useEffect(() => {
    return () => {
      if (clickTimeout) {
        clearTimeout(clickTimeout);
      }
    };
  }, [clickTimeout]);

  return (
    <div
      className="attachment-item d-flex align-items-center p-2 border  mb-2"
      onClick={handleClick}
      style={{ cursor: "pointer" }}
      title={`Click to view, double click to download ${filename}`}
    >
      <div className="file-icon me-2">{fileInfo.icon}</div>
      <span className="file-name flex-grow-1">{filename}</span>
      <small className="text-muted me-2">
        <em>Click to view, double click to download</em>
      </small>
    </div>
  );
};

// Add these options to the top of the file with other constants
const TIRE_OPTIONS = [
  "Cushion",
  "Pneumatic",
  "Polyurethane",
  "Solid Rubber",
  "Super Elastic",
];

const CONDITION_OPTIONS = [
  "New",
  "Like New",
  "Very Good",
  "Good",
  "Normal",
  "Bad",
  "Very Bad",
];

const ATTACHMENT_OPTIONS = [
  "Side Shifter",
  "Double Clamp",
  "Double Side Shifter",
  "Rotator",
  "Triple Clamp",
  "Triple Side Shifter",
  "Drum Clamp",
  "Fork Extension",
  "Clamp Fork",
  "Load Guard",
  "Push Fork",
  "Bulk Material Bucket",
  "Load Pin",
  "Fork Positioner",
  "Double Pallet Clamp",
  "Fork Pallet Coupler",
];

const ADD_EQUIPMENT_OPTIONS = [
  { id: 1, key: "3rd_valve" },
  { id: 2, key: "4th_valve" },
  { id: 3, key: "spotlight_rear" },
  { id: 4, key: "spotlight_front" },
  { id: 5, key: "overhead_guard" },
  { id: 6, key: "front_pane" },
  { id: 7, key: "weatherproof_cover" },
  { id: 8, key: "heater" },
  { id: 9, key: "load_guard_grill" },
  { id: 10, key: "solenoid_valve" },
  { id: 11, key: "oil_separator" },
  { id: 12, key: "diesel_particle_filter" },
  { id: 13, key: "road_traffic_regulation" },
  { id: 14, key: "weatherproof_cabin" },
  { id: 15, key: "explosion_proof" },
  { id: 16, key: "pulse_control" },
  { id: 17, key: "initial_stroke" },
  { id: 18, key: "air_condition" },
  { id: 19, key: "full_free_lift" },
  { id: 20, key: "ce_certificate" },
  { id: 21, key: "special_trucks" },
  { id: 22, key: "stainless_steel" },
  { id: 23, key: "cold_store" },
  { id: 24, key: "scales" },
  { id: 25, key: "twin_tires" },
  { id: 26, key: "safety_light" },
  { id: 27, key: "safety_pilot" },
  { id: 28, key: "non_marking_tires" },
  { id: 29, key: "lithium_ion_technology" },
  { id: 30, key: "double_deck_loading" },
  { id: 31, key: "self_driving" },
  { id: 32, key: "rear_view_mirror" },
  { id: 33, key: "side_mirrors" },
  { id: 34, key: "joystick" },
  { id: 35, key: "beacon_light" },
  { id: 36, key: "wipers" },
  { id: 37, key: "single_pedal" },
  { id: 38, key: "heated_seat" },
  { id: 39, key: "led" },
  { id: 40, key: "deep_reach" },
  { id: 41, key: "wire_guidance" },
  { id: 42, key: "galvanized" },
  { id: 43, key: "3_wheel" },
  { id: 44, key: "seat" },
];

const CreateAssetPage = () => {
  const { t } = useTranslation();

  const loadCentreOptions = [
    t("assets.options.horizontal_reach"),
    t("assets.options.basket_load"),
  ];

  const mastTypes = [
    { value: 0, option: t("assets.options.none") },
    { value: 1, option: t("assets.options.standard") },
    { value: 2, option: t("assets.options.duplex") },
    { value: 3, option: t("assets.options.triplex") },
    { value: 5, option: t("assets.options.quattro") },
    { value: 9, option: t("assets.options.telescopic") },
  ];

  const engineTypeOptions = [
    { value: "Diesel", option: t("assets.options.diesel") },
    { value: "Electric", option: t("assets.options.electric") },
    { value: "LPG", option: t("assets.options.lpg") },
    { value: "Gasoline", option: t("assets.options.gasoline-gas") },
    { value: "Hybrid", option: t("assets.options.hybrid") },
    { value: "Fuel-Cell", option: t("assets.options.fuel-cell") },
    { value: "Li-Ion", option: t("assets.options.lithium-ion") },
    { value: "manual/none", option: t("assets.options.hand") },
  ];
  console.log("Gasoline translation:", t("assets.options.gasoline"));

  const location = useLocation();
  const assetData = location.state?.assetData;
  console.log("asset data = > ", assetData);

  useEffect(() => {
    if (assetData?.additional_equipment) {
      setSelectedEquipment(assetData.additional_equipment);
    }
  }, [assetData]);

  // const [newAsset, setNewAsset] = useState(assetData || { ...initialAssets });
  const [newAsset, setNewAsset] = useState(
    assetData || { ...latestInitialAssets }
  );
  const [attachments, setAttachments] = useState([]);
  const [documents, setDocuments] = useState([]);
  const [showMediaUpload, setShowMediaUpload] = useState(false);
  const [currentStep, setCurrentStep] = useState(0);
  const [price, setPrice] = useState("");
  const [currency, setCurrency] = useState("USD");
  const [nettoPrice, setNettoPrice] = useState("");
  const [nettoCurrency, setNettoCurrency] = useState("Netto_euro");
  const [selectedPlatform, setSelectedPlatform] = useState("");
  const [customPlatform, setCustomPlatform] = useState("");
  const [selectedVisibleOption, setSelectedVisibleOption] = useState("");
  const [uniqueID, setUniqueID] = useState("");
  const [machineAvailable, setMachineAvailable] = useState("");
  const [loadCentre, setLoadCentre] = useState(0);
  const [selectedAttachment, setSelectedAttachment] = useState("");
  const [customAttachment, setCustomAttachment] = useState("");
  const [customEquipment, setCustomEquipment] = useState("");
  const [selectedEquipment, setSelectedEquipment] = useState([]);
  const [showAttachments, setShowAttachments] = useState(false);
  const [isBatteryAvailable, setIsBatteryAvailable] = useState(false);
  const [selectedFiles, setSelectedFiles] = useState(new DataTransfer().files);
  const [warehouses, setWarehouses] = useState([]);
  const [selectedWarehouse, setSelectedWarehouse] = useState(null);
  const [selectedContractWarehouse, setSelectedContractWarehouse] =
    useState(null);

  const [blockAssetChange, setBlockAssetChange] = useState(false);
  const [fileSizeError, setFileSizeError] = useState("");

  const [isLoading, setIsLoading] = useState(false);
  const [checboxValue, setCheckboxValue] = useState(false);
  const [contracts, setContracts] = useState([
    {
      id: 1,
      customerCompany: "TechCorp Solutions",
      customerName: "John Smith",
      customerPhone: "+49 30 12345678",
      customerNo: "CUST001",
      contractType: "rental",
      contractPrice: 2500,
      contractStart: "15.01.2024",
      contractEnd: "15.01.2025",
      customerLocation: "10115, Berlin, Germany",
    },
    {
      id: 2,
      customerCompany: "Digital Dynamics",
      customerName: "Sarah Johnson",
      customerPhone: "+49 89 87654321",
      customerNo: "CUST002",
      contractType: "leasing",
      contractPrice: 4800,
      contractStart: "01.03.2024",
      contractEnd: "01.03.2026",
      customerLocation: "80331, Munich, Germany",
    },
  ]);

  const [historyLog, setHistoryLog] = useState([
    {
      id: 1,
      contractId: 1,
      action: "Created",
      details: "Contract created for TechCorp Solutions",
      timestamp: "15.01.2024 10:30",
      user: "Admin",
    },
    {
      id: 2,
      contractId: 2,
      action: "Modified",
      details: "Price updated from €4500 to €4800",
      timestamp: "05.03.2024 14:20",
      user: "Manager",
    },
  ]);

  const handleRemoveFile = (indexToRemove) => {
    const dt = new DataTransfer();

    for (let i = 0; i < selectedFiles.length; i++) {
      if (i !== indexToRemove) {
        dt.items.add(selectedFiles[i]);
      }
    }

    setSelectedFiles(dt.files);
  };

  const handleCheckboxToggle = (e) => {
    const isChecked = e.target.checked;
    setCheckboxValue(isChecked);

    if (isChecked) {
      // Update delivery fields from invoice in contracts[0]
      setNewAsset((prev) => {
        const updatedContracts = [...prev.contracts];
        updatedContracts[0] = {
          ...updatedContracts[0],
          delivery_address_street:
            updatedContracts[0].invoice_address_street || "",
          delivery_address_city: updatedContracts[0].invoice_address_city || "",
          delivery_address_country:
            updatedContracts[0].invoice_address_country || "",
          delivery_address_zip: updatedContracts[0].invoice_address_zip || "",
        };

        return {
          ...prev,
          contracts: updatedContracts,
        };
      });
    }
  };

  const getWarehouses = async () => {
    try {
      const url = API_END_POINTS.warehouses;
      if (!url) {
        throw new Error("API endpoint not defined");
      }
      const response = await getProtected(url);
      console.log("response warehouse = ", response);
      if (Array.isArray(response) && response?.length > 0) {
        console.log("setting warehouses = ", response);
        setWarehouses(response);
      }
    } catch (error) {
      if (error.response?.status === 401) {
        toast.error(t("dashboardToasters.sessionExpiration"));
        navigate("/login");
        return;
      }
      toast.error(t("dashboardToasters.genricError"));
    }
  };

  const handleWarehouseChange = (e) => {
    console.log("value == ", e.target.value);
    const warehouseId = e.target.value;
    console.log("warehouses = ", warehouses);
    const selectedWarehousee = warehouses.find(
      (warehouse) => warehouse?.id == warehouseId
    );
    console.log("selected warehouse = ", selectedWarehousee);

    if (selectedWarehousee) {
      setSelectedWarehouse(selectedWarehousee);
      setNewAsset((prev) => ({
        ...prev,
        warehouse: warehouseId,
        dealer_street: selectedWarehousee?.warehouse_street || "",
        dealer_city: selectedWarehousee?.warehouse_city || "",
        dealer_zip: selectedWarehousee?.warehouse_zip || "",
        dealer_country: selectedWarehousee?.warehouse_country || "",
      }));
    } else {
      setSelectedWarehouse(null);
      setNewAsset((prev) => ({
        ...prev,
        warehouse: null,
        dealer_street: "",
        dealer_city: "",
        dealer_zip: "",
        dealer_country: "",
      }));
    }
  };

  const handleWarehouseChange2 = (e) => {
    console.log("value == ", e.target.value);
    const warehouseId = e.target.value;
    console.log("warehouses = ", warehouses);
    const selectedWarehousee = warehouses.find(
      (warehouse) => warehouse?.id == warehouseId
    );
    console.log("selected warehouse = ", selectedWarehousee);

    if (selectedWarehousee) {
      setSelectedContractWarehouse(selectedWarehousee);
      setNewAsset((prev) => {
        const updatedAddressFields = {
          invoice_address_street: selectedWarehousee?.warehouse_street || "",
          invoice_address_city: selectedWarehousee?.warehouse_city || "",
          invoice_address_zip: selectedWarehousee?.warehouse_zip || "",
          invoice_address_country: selectedWarehousee?.warehouse_country || "",
        };

        const updatedContracts = [...(prev.contracts || [])];
        if (updatedContracts.length > 0) {
          updatedContracts[0] = {
            ...updatedContracts[0],
            ...updatedAddressFields,
          };
        }

        return {
          ...prev,
          ...updatedAddressFields,
          contracts: updatedContracts,
        };
      });
    } else {
      setSelectedContractWarehouse(null);
      setNewAsset((prev) => {
        const updatedAddressFields = checboxValue
          ? {
              invoice_address_street: "",
              invoice_address_city: "",
              invoice_address_zip: "",
              invoice_address_country: "",

              delivery_address_street: "",
              delivery_address_city: "",
              delivery_address_zip: "",
              delivery_address_country: "",
            }
          : {
              invoice_address_street: "",
              invoice_address_city: "",
              invoice_address_zip: "",
              invoice_address_country: "",
            };

        const updatedContracts = [...(prev.contracts || [])];
        if (updatedContracts.length > 0) {
          updatedContracts[0] = {
            ...updatedContracts[0],
            ...updatedAddressFields,
          };
        }

        return {
          ...prev,
          ...updatedAddressFields,
          contracts: updatedContracts,
        };
      });

      setCheckboxValue(false);
    }
  };

  const [showHistoryModal, setShowHistoryModal] = useState(false);
  const [editingHistory, setEditingHistory] = useState(null);

  // const [selectedCategory , setSelectedCategory] = useState("Forklifts");

  const navigate = useNavigate();
  const [isBatteryChargerAvailable, setIsBatteryChargerAvailable] =
    useState(false);

  const steps = [
    { title: t("steps.assetBasicInformation"), icon: <FaClipboardList /> },
    {
      title: t("steps.assetFinancialInformation"),
      icon: <FaPaperclip />,
    },
    {
      title: t("steps.contractInformation"),
      icon: <FaListUl />,
    },
  ];

  const [batterySpecs, setBatterySpecs] = useState({
    manufacturer: "",
    batteryType: "",
    model: "",
    nominalVoltage: "",
    batteryCapacity: "",
    yearOfManufacture: "",
    additionalEquipment: "",
    length: "",
    width: "",
    weight: "",
    casing: "",
    location: "",
  });

  // charger specifications

  // const [chargerSpecifications, setChargerSpecifications] = useState({
  //   batteryManufacturer: "",
  //   batteryChargerType: "",
  //   batteryModel: "",
  //   batteryNominalVoltage: "",
  //   batteryAmp: "",
  //   batteryACVoltage: "",
  //   batteryYearOfManufacturer: "",
  //   batteryAdditionalEquipment: "",
  //   batteryLocation: "",
  // });

  // categories

  const categories = [
    { value: "Forklifts", option: t("assets.categories.forklifts") },
    { value: "Batteries", option: t("assets.categories.batteries") },
    { value: "Chargers", option: t("assets.categories.chargers") },
    { value: "Attachments", option: t("assets.categories.attachments") },
    { value: "Lift Masts", option: t("assets.categories.lift_masts") },
    { value: "Work Platforms", option: t("assets.categories.work_platforms") },
    {
      value: "Cleaning Equipment",
      option: t("assets.categories.cleaning_equipment"),
    },
    { value: "Spare Parts", option: t("assets.categories.spare_parts") },
    {
      value: "Construction Machinery",
      option: t("assets.categories.construction_machinery"),
    },
  ];

  const [selectedCategory, setSelectedCategory] = useState("Forklifts");

  const [selectedType, setSelectedType] = useState("none");

  const [selectedLoadCenter, setSelectedLoadCentre] = useState(0);

  const [selectedEngineType, setSelectedEngineType] = useState(
    engineTypeOptions[0]?.value || ""
  );
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  useEffect(() => {
    console.log("new asset => ", newAsset);
  }, [newAsset]);

  useEffect(() => {
    getWarehouses();
    // getBookHistory();
  }, []);

  const handleChange = (e) => {
    setBlockAssetChange(true);
    if (currentStep === 2) {
      console.log("contract info tab ...... ");
      const name = e.target.name;
      const value = e.target.value;

      console.log("checkbox state = ", e.target.checked);

      if (e.target.type === "checkbox") {
        setCheckboxValue(e.target.checked);
      }

      if (
        name === "name" ||
        name === "email" ||
        name === "phone_number" ||
        name === "customer_number" ||
        name === "customer_company"
      ) {
        setNewAsset((prev) => {
          const updatedContract = [...(prev.contracts || [])];
          const firstContract = updatedContract[0] || {};

          updatedContract[0] = {
            ...firstContract,
            customer: {
              ...firstContract.customer,
              [name]: value,
            },
          };

          return {
            ...prev,
            contracts: updatedContract,
          };
        });
      } else {
        setNewAsset((prev) => {
          const updatedContract = [...(prev.contracts || [])];
          const firstContract = updatedContract[0] || {};

          updatedContract[0] = {
            ...firstContract,
            [name]: value,
          };

          return {
            ...prev,
            contracts: updatedContract,
          };
        });
      }
      console.log("name = ", name);
      return;
    }
    const { name, value, type, files } = e.target;
    console.log("Dealer Id : ", type);
    console.log("name = ", name);
    if (name === "charger_yom") {
      setNewAsset((prev) => {
        return {
          ...prev,
          [name]: "2025-05-01",
        };
      });
      return;
    }
    if (type === "file") {
      const handleChange = (e) => {
        const { name, value, type, files } = e.target;

        if (type === "file") {
          if (files && files.length > 0) {
            const fileArray = Array.from(files);
            const maxFileSize = 10 * 1024 * 1024; // 10MB
            const validFileTypes = {
              "image/jpeg": "image",
              "image/png": "image",
              "image/gif": "image",
              "application/pdf": "document",
              "application/msword": "document",
              "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
                "document",
              "application/vnd.ms-excel": "document",
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":
                "document",
            };

            const validFiles = fileArray.filter((file) => {
              if (!validFileTypes[file.type]) {
                toast.error(t("dashboardToasters.invalidFile"));
                return false;
              }

              if (file.size > maxFileSize) {
                toast.error(t("dashboardToasters.largeFile"));
                return false;
              }

              return true;
            });

            if (validFiles.length > 0) {
              const filesWithType = validFiles.map((file) => ({
                file,
                type: validFileTypes[file.type],
                preview:
                  validFileTypes[file.type] === "image"
                    ? URL.createObjectURL(file)
                    : null,
                name: file.name,
              }));

              setAttachments((prev) => [...prev, ...filesWithType]);
              setShowAttachments(true);
            }
          }
        } else {
          console.log("name = ", name, " value = ", value);
          setNewAsset((prev) => ({
            ...prev,
            [name]: value,
            ...(name === "status" && { condition: value }),
          }));
        }
      };
    } else {
      if (name === "available") {
        setMachineAvailable(value);
        console.log("name", name);
        console.log("Value", value);
      } else {
        console.log("Adding new asset payload Latest Initial Assets");
        console.log("name - ", name, " value = ", value);

        // let parsedValue = value;

        // 🔑 Convert to number for backend enums
        // For enum fields, cast to number safely
        let parsedValue = value;

        // 🔑 Convert to number for backend enums
        if (
          [
            "battery_type",
            "mast_type",
            "tire_type",
            "chargerLoadertype",
            "workplatform_enginetype",
            "attachment_toc",
            "attachment_toc",
            "attachment_isoclass",
            "cleaning_toc",
            "sparetype",
            "construction_classification",
            "liftmast_classification",
            "workplatform_toc",
            // "workplatform_toc",
            // "technical_condition",
          ].includes(name)
        ) {
          parsedValue = value ? parseInt(value, 10) : null;
          if (isNaN(parsedValue)) parsedValue = null;
        }

        setNewAsset((prev) => ({ ...prev, [name]: parsedValue }));
      }
    }
  };

  const removeAttachment = (attachmentId) => {
    setAttachments((prev) =>
      prev.filter((attachment) => attachment.id !== attachmentId)
    );
  };

  function isValidContractPeriod(contract_start, contract_end) {
    const startDate = new Date(contract_start);
    const endDate = new Date(contract_end);
    if (isNaN(startDate.getTime()) || isNaN(endDate.getTime())) {
      return false;
    }

    return startDate < endDate;
  }

  const handleCreateAsset = async (e) => {
    e.preventDefault();

    if (
      newAsset?.contracts?.[0]?.contract_start &&
      newAsset?.contracts?.[0]?.contract_end &&
      Array.isArray(newAsset.contracts) &&
      !isValidContractPeriod(
        newAsset?.contracts?.[0]?.contract_start,
        newAsset?.contracts?.[0]?.contract_end
      )
    ) {
      toast.warn(t("dashboardToasters.contractDateValidation"));
      return;
    }

    if (
      newAsset?.contracts?.[0]?.delivery_address_zip &&
      Array.isArray(newAsset.contracts) &&
      isNaN(Number(newAsset?.contracts?.[0]?.delivery_address_zip))
    ) {
      toast.warn(t("dashboardToasters.zipCodeInteger"));
      return;
    }
    if (
      newAsset?.contracts?.[0]?.invoice_address_zip &&
      Array.isArray(newAsset.contracts) &&
      isNaN(Number(newAsset?.contracts?.[0]?.invoice_address_zip))
    ) {
      toast.warn(t("dashboardToasters.zipCodeInteger"));
      return;
    }

    const { manufacturer, asset_type, serial_no, year_of_manufacture } =
      newAsset;
    if (
      !manufacturer?.trim() ||
      !asset_type?.trim() ||
      !serial_no.trim() ||
      !normalizeYearOfManufacture(year_of_manufacture)
    ) {
      toast.error(t("dashboardToasters.fileAllFields"));
      return;
    }
    try {
      setIsLoading(true);
      const formData = new FormData();

      // Add all asset data to formData
      Object.entries(newAsset).forEach(([key, value]) => {
        if (
          value !== null &&
          value !== undefined &&
          key !== "attachments" &&
          key !== "additional_equipment" &&
          key !== "contracts"
        ) {
          const normalizedValue =
            key === "year_of_manufacture"
              ? normalizeYearOfManufacture(value)
              : value;
          formData.append(key, normalizedValue);
        }
      });
      if (Array.isArray(newAsset.additional_equipment)) {
        // Always use English translation for payload
        const enT = i18next.getFixedT("en");
        newAsset.additional_equipment.forEach((id) => {
          const option = ADD_EQUIPMENT_OPTIONS.find((opt) => opt.id === id);
          if (option) {
            // Get the English display value
            const englishDisplayName = enT(`assets.options.${option.key}`);
            formData.append("additional_equipment", englishDisplayName);
          }
        });
      }
      console.log(
        "additional_equipment to send:",
        newAsset.additional_equipment
      );

      if (
        newAsset?.contracts?.[0]?.contract_start &&
        newAsset?.contracts?.[0]?.contract_end &&
        Array.isArray(newAsset.contracts)
      ) {
        formData.append("contracts", JSON.stringify(newAsset.contracts));
      }

      // Add attachments
      attachments.forEach(({ file }) => {
        formData.append("attachments", file);
      });

      // Add documents if needed
      documents.forEach((doc) => {
        formData.append("documents", doc);
      });

      const response = assetData
        ? await postProtected(
            `${API_END_POINTS.updateAssets}/${assetData.id}`,
            formData,
            {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            }
          )
        : await postProtected(API_END_POINTS.createAssets, formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          });

      if (response?.id) {
        if (selectedFiles) {
          await handleUpload(response?.id);
        }

        setNewAsset({ ...latestInitialAssets });
        setAttachments([]);
        setDocuments([]);
        setShowMediaUpload(false);
        setSelectedFiles(null);
        toast.success(t("assets.create.fields.success"));
        navigate("/dashboard");
      }
    } catch (e) {
      if (e.response?.status === 401) {
        toast.error(t("dashboardToasters.sessionExpiration"));
        navigate("/login");
        return;
      }

      console.error("Error creating/updating asset:", e);
      showApiErrorToasts(toast, e?.response?.data, t("assets.create.fields.error"));
    } finally {
      setIsLoading(false);
    }
  };

  const handleNextStep = () => {
    if (currentStep < steps.length - 1) {
      setCurrentStep(currentStep + 1);
    }
  };

  const handlePreviousStep = () => {
    if (currentStep > 0) {
      setCurrentStep(currentStep - 1);
    }
  };

  const handlePlatformChange = (e) => {
    const value = e.target.value;
    setSelectedPlatform(value);
    console.log("selected platform", value);
    setNewAsset({
      ...newAsset,
      platform: value,
    });

    // Clear custom InputField if a predefined option is selected
    if (value !== "other") {
      setCustomPlatform("");
    }
  };

  const handleVisibleChange = (e) => {
    setSelectedVisibleOption(e.target.value);
    setNewAsset({
      ...newAsset,
      visible: e.target.value,
    });
  };

  const generateUniqueID = () => {
    const randomID = Math.floor(1000000 + Math.random() * 9000000).toString();
    setUniqueID(randomID);
  };

  useEffect(() => {
    generateUniqueID();
  }, []);

  const handleUniqueIDChange = (e) => {
    setUniqueID(e.target.value);
    setNewAsset({
      ...latestInitialAssets,
      asset_id: e.target.value,
    });
  };

  const handleAttachmentChange = (e) => {
    const value = e.target.value;
    setSelectedAttachment(value);

    // Clear custom InputField if a predefined option is selected
    if (value !== "other") {
      setCustomAttachment("");
    }
  };
  const handleEquipmentChange = (e) => {
    const value = e.target.value;

    // If "other" is selected, keep the custom equipment InputField; otherwise, clear it
    if (value === "other") {
      setSelectedEquipment((prev) => [...prev, value]); // Add "other" to selected equipment
    } else {
      setSelectedEquipment(value); // Set selected equipment to the chosen option
      setCustomEquipment(""); // Clear custom equipment InputField
    }
  };

  // Example of defining visibleOptions based on some criteria
  const visibleOptions = attachments.filter(
    (attachment) => attachment.isVisible
  );

  // New function to handle step click
  const handleStepClick = (index) => {
    setCurrentStep(index);
  };

  // fxn's for changing state for battery Available

  const handleBatteryAvailable = (event) => {
    const value = event.target.value === "true"; // Convert string to boolean
    setIsBatteryAvailable(value);
    setNewAsset({
      ...newAsset,
      battery: value,
    });
    console.log("Battery Available:", value);
  };
  const handleBatteryChargerAvailable = (event) => {
    const value = event.target.value === "true"; // Convert string to boolean
    setIsBatteryChargerAvailable(value);
    setNewAsset({
      ...newAsset,
      battery_charger: value,
    });
    console.log("Battery Charger Available:", value);
  };
  const InputWithExplanation = ({ label, explanation, children }) => {
    return (
      <div className="form-group">
        <div className="field-label-container">
          <label>{label}</label>
          <div className="explanation-icon">
            <i className="fas fa-info-circle" />
            <div className="explanation-tooltip">{explanation}</div>
          </div>
        </div>
        {children}
      </div>
    );
  };

  const ButtonList = () => {
    return (
      <div className="mx-2 sm:mx-4 w-full overflow-x-auto my-2 flex items-center bg-white py-2 shadow-md">
        <div className="flex space-x-1 sm:space-x-2 px-2 sm:px-0 min-w-max mx-auto">
          {categories.map((category, index) => (
            <button
              disabled={blockAssetChange}
              key={index}
              className={`${
                blockAssetChange ? "cursor-not-allowed" : "cursor-pointer"
              } font-medium py-[.5rem] px-[.6rem] sm:px-[.8rem] text-xs sm:text-sm md:text-base gap-2 transition-colors duration-200 whitespace-nowrap ${
                selectedCategory === category.value
                  ? "bg-blue-500 hover:bg-blue-600 text-white"
                  : "bg-gray-200 text-gray-800"
              }`}
              onClick={() => {
                setSelectedCategory(category.value);
                setNewAsset((prev) => {
                  return {
                    ...prev,
                    asset_type: category.value,
                  };
                });
              }}
            >
              {category.option}
            </button>
          ))}
        </div>
      </div>
    );
  };

  const Step = ({ step, index, currentStep, steps, handleStepClick }) => {
    return (
      <div
        className={`border-2 border-black flex flex-col items-center mx-1 sm:mx-2 md:mx-9 ${
          index === 0
            ? "step1"
            : index === 1
            ? "step2"
            : index === 2
            ? "step3"
            : "step4"
        }`}
        key={index}
        onClick={() => handleStepClick(index)}
      >
        <div
          className={`flex border-2 border-black  items-center justify-center  w-8 h-8 sm:w-10 sm:h-10 md:w-12 md:h-12 cursor-pointer transition-colors duration-300 ${
            currentStep >= index
              ? "bg-blue-500 text-white"
              : "bg-gray-200 text-gray-500"
          }`}
        >
          {step.icon}
        </div>

        {index < steps.length - 1 && (
          <div className="hidden sm:block h-1 w-16 md:w-24 lg:w-32 bg-gray-200 mt-4">
            <div
              className={`h-full ${
                currentStep > index ? "bg-blue-500" : "bg-gray-200"
              }`}
            />
          </div>
        )}

        <div
          className={`mt-2 text-xs sm:text-sm md:text-base text-center transition-colors duration-300 ${
            currentStep === index
              ? "font-bold text-black"
              : "font-normal text-gray-500"
          }`}
        >
          {step.title}
        </div>
      </div>
    );
  };

  const handleRadioChange = (value) => {
    setNewAsset((prev) => ({
      ...prev,
      freihub: value,
    }));
  };

  const handleFileChange = (e) => {
    const dt = new DataTransfer();
    let hasLargeFile = false;
    const documentExtensions = [".pdf", ".xlsx", ".xls", ".docx", ".doc"];
    const maxImageSize = 10 * 1024 * 1024; // 10 MB — matches backend
    const maxDocumentSize = 10 * 1024 * 1024; // 10 MB — matches backend

    for (let i = 0; i < selectedFiles.length; i++) {
      dt.items.add(selectedFiles[i]);
    }

    for (let i = 0; i < e.target.files.length; i++) {
      const file = e.target.files[i];
      const fileExtension = file.name
        .toLowerCase()
        .substring(file.name.lastIndexOf("."));
      const maxSize = documentExtensions.includes(fileExtension)
        ? maxDocumentSize
        : maxImageSize;

      if (file.size > maxSize) {
        hasLargeFile = true;
      } else {
        dt.items.add(file);
      }
    }
    if (hasLargeFile) {
      setFileSizeError(
        "Please reduce your file size. Images and documents must each be less than 10 MB."
      );
    } else {
      setFileSizeError("");
    }

    setSelectedFiles(dt.files);
  };

  const handleUpload = async (id) => {
    console.log("file length = ", selectedFiles.length);
    if (selectedFiles.length == 0) return;
    const formData = new FormData();
    const documentExtensions = [".pdf", ".xlsx", ".docx"];
    const imageExtensions = [
      ".jpg",
      ".jpeg",
      ".png",
      ".gif",
      ".bmp",
      ".webp",
      ".svg",
    ];

    for (let i = 0; i < selectedFiles.length; i++) {
      const file = selectedFiles[i];
      const fileName = file.name.toLowerCase();

      const fileExtension = fileName.substring(fileName.lastIndexOf("."));

      if (documentExtensions.includes(fileExtension)) {
        formData.append("documents", file);
      } else if (imageExtensions.includes(fileExtension)) {
        formData.append("images", file);
      } else {
        console.warn(
          `Unknown file type: ${fileExtension} for file: ${file.name}`
        );
        formData.append("other", file);
      }
    }

    try {
      const url = `${baseURL}/assets/${id}/attachments/`;
      const response = await postProtected(url, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      console.log("response after uploading files = ", response);
    } catch (error) {
      if (error.response?.status === 401) {
        toast.error(t("dashboardToasters.sessionExpiration"));
        navigate("/login");
        return;
      } else if (error.response?.status === 413) {
        toast.error(t("dashboardToasters.largeFile"));
        return;
      }
      showApiErrorToasts(
        toast,
        error?.response?.data,
        t("dashboardToasters.largeFile")
      );
      console.error("Upload failed", error.response?.data || error.message);
    }
  };
  return (
    <div className="overflow-y-auto  w-full min-h-screen bg-gray-100 ">
      <HeroSection t={t} />
      {/* <HeroSection/> */}

      <h1 className="px-4 py-2  font-medium text-3xl ">Create Asset</h1>
      <ButtonList />
      <div className="w-full px-2 py-2 sm:px-4 md:px-6 lg:px-8">
        <div className="flex flex-row justify-between items-stretch w-full shadow-sm">
          {steps.map((step, index) => (
            <div
              className="relative border-2 border-gray-200 bg-white p-1 sm:p-2 md:p-3 lg:p-4 flex flex-col items-center flex-1 min-w-0 h-full"
              key={index}
            >
              {/* Step circle */}
              <div
                className={`flex items-center justify-center rounded-full border-2 ${
                  currentStep === index
                    ? "bg-blue-500 border-blue-500 text-white"
                    : "bg-white border-gray-300 text-gray-400"
                } w-6 h-6 xs:w-7 xs:h-7 sm:w-8 sm:h-8 md:w-10 md:h-10 lg:w-12 lg:h-12 xl:w-14 xl:h-14 border-2 border-blue-500 z-10 cursor-pointer transition-colors duration-300`}
                onClick={() => handleStepClick(index)}
              >
                <span className="text-xs sm:text-sm md:text-base lg:text-lg xl:text-xl">
                  {step.icon}
                </span>
              </div>

              {/* Step title */}
              <div className="mt-1 sm:mt-2 md:mt-3 lg:mt-4 text-center w-full px-1 flex-grow flex items-end">
                <div
                  className={`text-xs xs:text-xs sm:text-sm md:text-base lg:text-lg xl:text-xl font-medium leading-tight w-full ${
                    currentStep === index
                      ? "text-blue-500 font-bold"
                      : currentStep > index
                      ? "text-gray-700"
                      : "text-gray-400"
                  }`}
                >
                  <span className="block sm:inline break-words hyphens-auto">
                    {step.title}
                  </span>
                </div>
              </div>

              {/* Connector line */}
            </div>
          ))}
        </div>
      </div>

      <form onSubmit={handleCreateAsset} className="w-full px-4 py-1 ">
        {/* {selectedCategory === "Forklifts" && (
          <div className="flex gap-2 items-center mb-2">
            <button
              variant="primary"
              type="button"
              onClick={() => navigate("/dashboard")}
              className="bg-gray-200  text-black px-4 py-2 -md text-sm sm:text-base w-full sm:w-auto"
            >
              {t("common.cancel")}
            </button>
            <button
              variant="primary"
              type="submit"
              className={`bg-blue-600 hover:bg-blue-700 text-white px-4 py-2  text-sm sm:text-base w-full sm:w-auto ${
                isLoading ? "opacity-50 cursor-not-allowed" : ""
              }`}
              disabled={isLoading}
            >
              {t("common.buttons.save")}
            </button>
          </div>
        )} */}
        {currentStep === 0 && (
          <>
            {/* Truck basic information */}
            <AssetFormButtonGroup
              t={t}
              isLoading={isLoading}
              navigate={navigate}
            />

            {selectedCategory === "Chargers" && (
              <Chargers
                t={t}
                selectedFiles={selectedFiles}
                handleRemoveFile={handleRemoveFile}
                handleFileChange={handleFileChange}
                newAsset={newAsset}
                handleChange={handleChange}
                warehouses={warehouses}
                selectedWarehouse={selectedWarehouse}
                handleWarehouseChange={handleWarehouseChange}
              />
            )}

            {selectedCategory === "Batteries" && (
              <Batteries
                t={t}
                selectedFiles={selectedFiles}
                handleRemoveFile={handleRemoveFile}
                handleFileChange={handleFileChange}
                newAsset={newAsset}
                handleChange={handleChange}
                warehouses={warehouses}
                selectedWarehouse={selectedWarehouse}
                handleWarehouseChange={handleWarehouseChange}
              />
            )}

            {selectedCategory === "Forklifts" && (
              <div className="w-full flex flex-col gap-4 ">
                {/* Basic Information */}
                <div className="bg-white p-4 shadow-md">
                  <h2 className="text-xl font-medium mb-3 text-gray-800">
                    {t("assetPageHeadings.basics")}
                  </h2>

                  {/* Main container - maintains original layout on md+ screens */}
                  <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-2">
                    {/* Row 1: Manufacturer and Serial Number */}
                    <div className="col-span-1 md:col-span-1 lg:col-span-1 grid grid-cols-1 md:grid-cols-1 lg:grid-cols-2 gap-2">
                      <div>
                        <InputField
                          required
                          name="manufacturer"
                          value={newAsset.manufacturer}
                          maxLength={100}
                          onChange={handleChange}
                          label={t("assets.fields.manufacturer")}
                          explanation={t(
                            "assets.fields.explanation.manufacturer"
                          )}
                          placeholder={t(
                            "createAsset.placeholder.enterManufacturer"
                          )}
                        />
                      </div>

                      <div className="">
                        <InputField
                          name="type"
                          value={newAsset.type}
                          onChange={handleChange}
                          label={t("assets.fields.type")}
                          explanation={t("assets.fields.explanation.type")}
                          placeholder={t("createAsset.placeholder.enterType")}
                          maxLength={30}
                        />
                      </div>
                    </div>

                    <div className="gap-2 col-span-1 md:col-span-1 lg:col-span-3 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4">
                      <div>
                        <SelectField
                          name="classification"
                          value={newAsset.classification}
                          onChange={handleChange}
                          label={t("assets.fields.classification")}
                          required
                          explanation={t(
                            "assets.fields.explanation.classification"
                          )}
                          placeholder={t(
                            "createAsset.placeholder.enterClassification"
                          )}
                          menus={[
                            {
                              value: "",
                              option: t("assets.fields.selectClassification"),
                            },
                            {
                              value: "Other",
                              option: t("assets.options.other"),
                            },
                            {
                              value: "Rough-terrain-forklift",
                              option: t("assets.options.off_road_forklift"),
                            },
                            {
                              value: "Container-Stacker",
                              option: t("assets.options.container_handler"),
                            },
                            {
                              value: "Reach-stacker",
                              option: t("assets.options.reach_stacker"),
                            },
                            {
                              value: "Terminal tractor",
                              option: t("assets.options.terminal_tractor"),
                            },
                            {
                              value: "Tractor",
                              option: t("assets.options.tractor"),
                            },
                            {
                              value: "Trailer",
                              option: t("assets.options.trailer"),
                            },
                            {
                              value: "Electric platform trucks",
                              option: t(
                                "assets.options.electric_platform_cart"
                              ),
                            },
                            {
                              value: "Electric 3-wheel",
                              option: t("assets.options.electric_3_wheel"),
                            },
                            {
                              value: "Electric 4-wheel",
                              option: t("assets.options.electric_4_wheel"),
                            },
                            {
                              value: "Diesel Forklift",
                              option: t("assets.options.diesel_forklift"),
                            },
                            {
                              value: "Compact Forklift Truck",
                              option: t("assets.options.compact_forklift"),
                            },
                            {
                              value: "LPG Forklift",
                              option: t("assets.options.lpg_forklift"),
                            },
                            {
                              value: "Pallet truck",
                              option: t("assets.options.manual_pallet_truck"),
                            },
                            {
                              value: "Pallet Trucks Sit-down",
                              option: t("assets.options.standup_forklift"),
                            },
                            {
                              value: "Scissor elevating truck platform",
                              option: t("assets.options.scissor_lift"),
                            },
                            {
                              value: "Lift trucks with scales",
                              option: t(
                                "assets.options.pallet_truck_with_scale"
                              ),
                            },
                            {
                              value: "Hand pallet truck",
                              option: t("assets.options.hand"),
                            },
                            {
                              value: "Horizontal order picker",
                              option: t(
                                "assets.options.horizontal_order_picker"
                              ),
                            },
                            {
                              value: "Vertical order picker",
                              option: t("assets.options.vertical_order_picker"),
                            },
                            {
                              value: "High-lift pallet truck",
                              option: t("assets.options.high_lift_truck"),
                            },
                            {
                              value: "Stacker stand-on",
                              option: t("assets.options.standup_forklift"),
                            },
                            {
                              value: "High lift pallet trucks sit-down",
                              option: t("assets.options.high_lift_truck"),
                            },
                            {
                              value: "Reach truck",
                              option: t("assets.options.reach_truck"),
                            },
                            {
                              value: "Narrow aisle truck",
                              option: t("assets.options.narrow_aisle_truck"),
                            },
                            {
                              value: "Telescopic forklift, fixed",
                              option: t("assets.options.telescopic_forklift"),
                            },
                            {
                              value: "Telescopic forklift, rotating",
                              option: t("assets.options.telescopic_forklift"),
                            },
                            {
                              value: "Four-way loader",
                              option: t("assets.options.four_way_side_loader"),
                            },
                            {
                              value: "Four-way reachtruck",
                              option: t("assets.options.four_way_reach_truck"),
                            },
                            {
                              value: "Sideloader",
                              option: t("assets.options.side_loader"),
                            },
                            {
                              value: "Truck mounted forklift",
                              option: t(
                                "assets.options.truck_mounted_forklift"
                              ),
                            },
                            {
                              value: "Tugger-train-trailer",
                              option: t("assets.options.route_train_trailer"),
                            },
                            {
                              value: "CNG-Forklift",
                              option: t("assets.options.natural_gas_forklift"),
                            },
                            {
                              value: "Gasoline-Forklift",
                              option: t("assets.options.gasoline_forklift"),
                            },
                            {
                              value: "Electric stairclimber",
                              option: t("assets.options.electric_stairclimber"),
                            },
                            {
                              value: "Counterbalance forklift",
                              option: t(
                                "assets.options.counterbalance_forklift"
                              ),
                            },
                          ]}
                          selectClassName={
                            !newAsset.classification
                              ? "text-gray-400 font-light"
                              : "text-gray-900 font-normal"
                          }
                        />
                      </div>

                      <div>
                        <InputField
                          required
                          name="serial_no"
                          value={newAsset.serial_no}
                          onChange={handleChange}
                          placeholder={t(
                            "createAsset.placeholder.enterSerialNumber"
                          )}
                          label={`${t("assets.fields.machineSerialNo")} `}
                          explanation={t(
                            "assets.fields.explanation.machineSerialNo"
                          )}
                          maxLength={100}
                        />
                      </div>

                      <div className="">
                        <InputField
                          name="intern_no"
                          value={newAsset.intern_no}
                          onChange={handleChange}
                          maxLength={100}
                          placeholder={t(
                            "createAsset.placeholders.internNoPlaceholder"
                          )}
                          label={t("createAsset.placeholders.internNoLabel")}
                          explanation={t(
                            "createAsset.placeholders.internNoExplanation"
                          )}
                        />
                      </div>

                      <div className="">
                        <SelectField
                          name="status"
                          value={newAsset.status}
                          onChange={handleChange}
                          label={`${t("assets.fields.status")} *`}
                          explanation={t("assets.fields.explanation.status")}
                          placeholder={t("createAsset.placeholder.enterStatus")}
                          menus={[
                            {
                              value: "",
                              option: t("assets.fields.selectStatus"),
                            },
                            { value: "New", option: t("assets.options.new") },
                            { value: "Used", option: t("assets.options.used") },
                            {
                              value: "Short Time Hire",
                              option: t("assets.options.shortTermHire"),
                            },
                            {
                              value: "Demo",
                              option: "Demo",
                            },
                          ]}
                        />
                      </div>
                    </div>
                    {/* Row 2: Engine Type and Classification */}
                  </div>

                  {/* Row 3: Status, Country, Zip, and City all in one row */}
                  <div className="col-span-2 grid grid-cols-1 md:grid-cols-3 lg:grid-cols-6 gap-2">
                    <div>
                      <InputField
                        required
                        name="year_of_manufacture"
                        value={newAsset.year_of_manufacture || ""}
                        onChange={handleChange}
                        label={t("assets.fields.yearOfManufacture")}
                        explanation={t(
                          "assets.fields.explanation.yearOfManufacture"
                        )}
                        placeholder={t(
                          "createAsset.placeholder.enterYearOfManufacture"
                        )}
                        type="year"
                      />
                    </div>

                    <div>
                      <InputField
                        required
                        name="operating_hours"
                        type="number"
                        value={newAsset.operating_hours}
                        onChange={handleChange}
                        label={t("assets.fields.operatingHours")}
                        explanation={t(
                          "assets.fields.explanation.operatingHours"
                        )}
                        placeholder="Enter operating hours"
                        maxLength={8}
                      />
                    </div>

                    <div>
                      <InputField
                        name="capacity"
                        type="number"
                        value={newAsset.capacity}
                        onChange={handleChange}
                        label={t("assets.fields.capacity")}
                        explanation={t("assets.fields.explanation.capacity")}
                        placeholder={t("createAsset.placeholder.enterCapacity")}
                        maxLength={10}
                      />
                    </div>

                    <div>
                      <InputField
                        name="lift_height_mm"
                        type="number"
                        value={newAsset.lift_height_mm}
                        onChange={handleChange}
                        label={t("createAsset.placeholders.liftHeight")}
                        explanation={t(
                          "createAsset.placeholders.liftHeightExplanation"
                        )}
                        placeholder={t(
                          "createAsset.placeholders.liftHeightPlaceholder"
                        )}
                        maxLength={4}
                      />
                    </div>

                    <div>
                      <InputField
                        type="number"
                        name="machine_height_mm"
                        maxLength={4}
                        value={newAsset.machine_height_mm}
                        onChange={handleChange}
                        label={t("createAsset.placeholders.machineHeight")}
                        explanation={t(
                          "createAsset.placeholders.machineHeightPlaceholder"
                        )}
                        placeholder={t(
                          "createAsset.placeholders.machineHeightExplanation"
                        )}
                      />
                    </div>

                    <div className="col-span-1 flex gap-2 items-center">
                      <SelectField
                        name="mast_type"
                        value={selectedType}
                        onChange={(e) => {
                          const newType = e.target.value;
                          setSelectedType(newType);
                          setNewAsset((prev) => ({
                            ...prev,
                            mast_type: newType,
                          }));
                        }}
                        label={t("createAsset.placeholders.mastTypeLabel")}
                        explanation={t(
                          "createAsset.placeholders.mastTypeExplanation"
                        )}
                        placeholder={t(
                          "createAsset.placeholders.mastTypePlaceholder"
                        )}
                        menus={[
                          {
                            value: "",
                            option: t(
                              "createAsset.placeholders.mastTypePlaceholder"
                            ),
                          },
                          ...mastTypes.map((type) => ({
                            value: type?.value,
                            option: type?.option,
                          })),
                        ]}
                      />
                    </div>

                    {Array.isArray(warehouses) && warehouses?.length > 0 && (
                      <div className="col-span-1 md:col-span-2 lg:col-span-2">
                        <SelectField
                          name="warehouse"
                          value={selectedWarehouse?.id || ""}
                          onChange={(e) => {
                            handleWarehouseChange(e);
                          }}
                          label={t("createAsset.placeholders.warehouseLabel")}
                          explanation={t(
                            "createAsset.placeholders.warehouseExplanation"
                          )}
                          placeholder={t(
                            "createAsset.placeholders.warehousePlaceholder"
                          )}
                          menus={[
                            {
                              value: "",
                              option: t(
                                "createAsset.placeholders.warehousePlaceholder"
                              ),
                            },
                            ...warehouses.map((warehouse) => {
                              return {
                                value: warehouse.id,
                                option: warehouse.name,
                              };
                            }),
                          ]}
                        />
                      </div>
                    )}

                    <div>
                      <InputField
                        required
                        name="dealer_street"
                        value={newAsset.dealer_street}
                        onChange={handleChange}
                        maxLength={20}
                        label={t("createAsset.placeholders.street")}
                        placeholder={t(
                          "createAsset.placeholders.streetPlaceholder"
                        )}
                        explanation={t(
                          "createAsset.placeholders.streetExplanation"
                        )}
                      />
                    </div>

                    <div>
                      <InputField
                        required
                        name="dealer_city"
                        value={newAsset.dealer_city}
                        onChange={handleChange}
                        label={t("createAsset.placeholders.city")}
                        explanation={t(
                          "createAsset.placeholders.cityExplanation"
                        )}
                        placeholder={t(
                          "createAsset.placeholders.cityPlaceholder"
                        )}
                        maxLength={50}
                      />
                    </div>

                    <div>
                      <InputField
                        required
                        name="dealer_country"
                        value={newAsset.dealer_country}
                        onChange={handleChange}
                        label={t("createAsset.placeholders.country")}
                        explanation={t(
                          "createAsset.placeholders.countryExplanation"
                        )}
                        placeholder={t(
                          "createAsset.placeholders.countryPlaceholder"
                        )}
                        maxLength={50}
                      />
                    </div>

                    <div>
                      <InputField
                        required
                        name="dealer_zip"
                        value={newAsset.dealer_zip}
                        onChange={handleChange}
                        type="number"
                        label={t("createAsset.placeholders.zipCode")}
                        explanation={t(
                          "createAsset.placeholders.zipCodePlaceholder"
                        )}
                        placeholder={t(
                          "createAsset.placeholders.zipCodeExplanation"
                        )}
                        maxLength={7}
                      />
                    </div>

                    <div className="col-span-1 md:col-span-3 lg:col-span-4">
                      <div className="flex items-center gap-4">
                        <div className="flex-1">
                          <SelectField
                            name="technical_condition"
                            value={newAsset.technical_condition}
                            onChange={handleChange}
                            label={t(
                              "createAsset.placeholders.technicalConditionLabel"
                            )}
                            explanation={t(
                              "createAsset.placeholders.technicalConditionExplanation"
                            )}
                            placeholder={t(
                              "createAsset.placeholders.technicalConditionPlaceholder"
                            )}
                            menus={[
                              {
                                value: "",
                                option: t(
                                  "createAsset.placeholders.technicalConditionPlaceholder"
                                ),
                              },
                              {
                                value: 2,
                                option: t(
                                  "assets.technicalCondition.very_good"
                                ),
                              },
                              {
                                value: 3,
                                option: t("assets.technicalCondition.good"),
                              },
                              {
                                value: 4,
                                option: t("assets.technicalCondition.used"),
                              },
                              {
                                value: 5,
                                option: t("assets.technicalCondition.bad"),
                              },
                              {
                                value: 6,
                                option: t("assets.technicalCondition.very_bad"),
                              },
                              {
                                value: 7,
                                option: t("assets.technicalCondition.new"),
                              },
                            ]}
                          />
                        </div>

                        <div className="flex-1 col-span-2">
                          <SelectField
                            name="optical_condition"
                            value={newAsset.optical_condition}
                            onChange={handleChange}
                            label={t(
                              "createAsset.placeholders.opticalConditionLabel"
                            )}
                            explanation={t(
                              "createAsset.placeholders.opticalConditionExplanation"
                            )}
                            placeholder={t(
                              "createAsset.placeholders.opticalConditionPlaceholder"
                            )}
                            menus={[
                              {
                                value: "",
                                option: t(
                                  "createAsset.placeholders.opticalConditionPlaceholder"
                                ),
                              },
                              {
                                value: 2,
                                option: t(
                                  "assets.technicalCondition.very_good"
                                ),
                              },
                              {
                                value: 3,
                                option: t("assets.technicalCondition.good"),
                              },
                              {
                                value: 4,
                                option: t("assets.technicalCondition.used"),
                              },
                              {
                                value: 5,
                                option: t("assets.technicalCondition.bad"),
                              },
                              {
                                value: 6,
                                option: t("assets.technicalCondition.very_bad"),
                              },
                              {
                                value: 7,
                                option: t("assets.technicalCondition.new"),
                              },
                            ]}
                          />
                        </div>
                      </div>
                    </div>

                    <div className="mb-4 flex items-center col-span-1 md:col-span-3 lg:col-span-2 w-full">
                      <div className="flex flex-col gap-2 w-full">
                        <SelectField
                          name="engine_type"
                          value={selectedEngineType}
                          onChange={(e) => {
                            const newType = e.target.value;
                            setSelectedEngineType(newType);
                            setNewAsset((prev) => ({
                              ...prev,
                              engine_type: newType,
                            }));
                          }}
                          label={t("createAsset.placeholders.engineTypeLabel")}
                          explanation={t(
                            "createAsset.placeholders.engineTypeExplanation"
                          )}
                          placeholder={t(
                            "createAsset.placeholders.engineTypePlaceholder"
                          )}
                          menus={[
                            {
                              value: "",
                              option: t("assets.fields.selectEngineType"),
                            },
                            ...engineTypeOptions.map((opt) => ({
                              value: opt.value,
                              option: opt.option,
                            })),
                          ]}
                        />
                      </div>
                    </div>
                  </div>
                </div>

                <div className="bg-white p-4 shadow-md">
                  <h2 className="text-xl font-medium mb-3 text-gray-800">
                    {t("assetPageHeadings.details")}
                  </h2>

                  {/* Regular fields in responsive grid layout */}
                  <div className="grid grid-cols-1 gap-2 gap-y-2">
                    <div className="col-span-1 sm:col-span-3 grid grid-cols-1 md:grid-cols-3 lg:grid-cols-5 gap-x-4 gap-y-4 mr-4">
                      <InputField
                        name="closed_height_mm"
                        type="number"
                        value={newAsset.closed_height_mm || ""}
                        onChange={handleChange}
                        maxLength={4}
                        label={
                          <span className="whitespace-nowrap">
                            {t("createAsset.placeholders.closedHeight")}
                          </span>
                        }
                        explanation={t(
                          "createAsset.placeholders.closedHeightExplanation"
                        )}
                        placeholder={t(
                          "createAsset.placeholders.closedHeigthPlaceholder"
                        )}
                      />

                      <InputField
                        type="number"
                        name="machine_length_mm"
                        value={newAsset.machine_length_mm}
                        onChange={handleChange}
                        maxLength={4}
                        label={
                          <span className="whitespace-nowrap">
                            {t("createAsset.placeholders.machineLength")}
                          </span>
                        }
                        explanation={t(
                          "createAsset.placeholders.machineLengthExplanation"
                        )}
                        placeholder={t(
                          "createAsset.placeholders.machineLengthPlaceholder"
                        )}
                      />

                      <InputField
                        type="number"
                        name="machine_width_mm"
                        maxLength={4}
                        value={
                          newAsset.machine_width_mm > 0 &&
                          newAsset.machine_width_mm
                        }
                        onChange={handleChange}
                        label={
                          <span className="whitespace-nowrap">
                            {t("createAsset.placeholders.machineWidth")}
                          </span>
                        }
                        explanation={t(
                          "createAsset.placeholders.machineWidthPlaceholder"
                        )}
                        placeholder={t(
                          "createAsset.placeholders.machineWidthExplanation"
                        )}
                      />

                      <InputField
                        type="number"
                        name="machine_weight_kg"
                        maxLength={4}
                        value={newAsset.machine_weight_kg}
                        onChange={handleChange}
                        label={
                          <span className="whitespace-nowrap">
                            {t("createAsset.placeholders.machineWeigth")}
                          </span>
                        }
                        explanation={t(
                          "createAsset.placeholders.machineWeigthPlaceholder"
                        )}
                        placeholder={t(
                          "createAsset.placeholders.machineWeigthExplanation"
                        )}
                      />

                      <InputField
                        type="number"
                        name="load_center_mm"
                        maxLength={4}
                        value={newAsset.load_center_mm}
                        onChange={handleChange}
                        label={
                          <span className="whitespace-nowrap">
                            {t("createAsset.placeholders.loadCenter")}
                          </span>
                        }
                        explanation={t(
                          "createAsset.placeholders.loadCenterPlaceholder"
                        )}
                        placeholder={t(
                          "createAsset.placeholders.loadCenterExplanation"
                        )}
                      />
                    </div>

                    <div className="col-span-1 flex gap-2 items-center">
                      <div className="flex gap-2">
                        <div className="flex items-center flex-wrap gap-2">
                          {loadCentreOptions.map((load_center, index) => (
                            <button
                              key={index}
                              type="button"
                              className={`px-2 py-2 -md border transition-colors ${
                                selectedLoadCenter === index
                                  ? "bg-blue-500 hover:bg-blue-600 text-white "
                                  : "bg-white text-gray-800 border-gray-300 hover:bg-gray-100"
                              }`}
                              onClick={() => {
                                setSelectedLoadCentre(index);
                                setNewAsset((prev) => {
                                  return {
                                    ...prev,
                                    load_centre: index,
                                  };
                                });
                              }}
                            >
                              {load_center}
                            </button>
                          ))}
                        </div>
                      </div>
                    </div>

                    <div className="col-span-1 md:col-span-1 lg:col-span-5">
                      <div className="w-full">
                        <label className="block text-sm font-medium text-gray-700 mb-2">
                          {t("assets.create.fields.selectEquipment")}
                        </label>

                        <div className="relative">
                          {/* Custom Dropdown Trigger */}
                          <div
                            className="block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm bg-white cursor-pointer hover:border-gray-400 focus-within:ring-2 focus-within:ring-blue-500 focus-within:border-blue-500 min-h-[38px] flex items-center justify-between"
                            onClick={() => setIsDropdownOpen(!isDropdownOpen)}
                          >
                            <div className="flex-1 flex flex-wrap gap-1 items-center">
                              {selectedEquipment &&
                              selectedEquipment.length > 0 ? (
                                selectedEquipment.map((id) => {
                                  const option = ADD_EQUIPMENT_OPTIONS.find(
                                    (opt) => opt.id === id
                                  );
                                  if (!option) return null;
                                  return (
                                    <span
                                      key={id}
                                      className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-blue-100 text-blue-800"
                                    >
                                      {t(`assets.options.${option.key}`)}
                                      <button
                                        type="button"
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          const newSelection =
                                            selectedEquipment.filter(
                                              (item) => item !== id
                                            );
                                          setSelectedEquipment(newSelection);
                                          setNewAsset((prev) => ({
                                            ...prev,
                                            additional_equipment: newSelection,
                                          }));
                                        }}
                                        className="ml-1 inline-flex items-center justify-center w-4 h-4 text-blue-400 hover:bg-blue-200 hover:text-blue-500 focus:outline-none focus:bg-blue-500 focus:text-white rounded-full"
                                      >
                                        <span className="sr-only">Remove</span>
                                        <svg
                                          className="w-2 h-2"
                                          stroke="currentColor"
                                          fill="none"
                                          viewBox="0 0 8 8"
                                        >
                                          <path
                                            strokeLinecap="round"
                                            strokeWidth="1.5"
                                            d="m1 1 6 6m0-6-6 6"
                                          />
                                        </svg>
                                      </button>
                                    </span>
                                  );
                                })
                              ) : (
                                <span className="text-gray-500 text-sm">
                                  Select equipment...
                                </span>
                              )}
                            </div>

                            {/* Dropdown Arrow */}
                            <svg
                              className={`w-5 h-5 text-gray-400 transition-transform duration-200 ${
                                isDropdownOpen ? "transform rotate-180" : ""
                              }`}
                              fill="none"
                              stroke="currentColor"
                              viewBox="0 0 24 24"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth={2}
                                d="M19 9l-7 7-7-7"
                              />
                            </svg>
                          </div>

                          {/* Dropdown Options */}
                          {isDropdownOpen && (
                            <div className="absolute z-10 w-full mt-1 bg-white border border-gray-300 rounded-md shadow-lg max-h-60 overflow-auto">
                              {ADD_EQUIPMENT_OPTIONS.map((option) => {
                                const isSelected = selectedEquipment.includes(
                                  option.id
                                );
                                return (
                                  <div
                                    key={option.id}
                                    className={`px-3 py-2 cursor-pointer hover:bg-gray-50 flex items-center justify-between ${
                                      isSelected
                                        ? "bg-blue-50 text-blue-700"
                                        : "text-gray-900"
                                    }`}
                                    onClick={() => {
                                      let newSelection;
                                      if (isSelected) {
                                        newSelection = selectedEquipment.filter(
                                          (val) => val !== option.id
                                        );
                                      } else {
                                        newSelection = [
                                          ...selectedEquipment,
                                          option.id,
                                        ];
                                      }
                                      setSelectedEquipment(newSelection);
                                      // Update newAsset
                                      setNewAsset((prev) => ({
                                        ...prev,
                                        additional_equipment: newSelection,
                                      }));
                                    }}
                                  >
                                    <span>
                                      {t(`assets.options.${option.key}`)}
                                    </span>
                                    {isSelected && (
                                      <svg
                                        className="w-4 h-4 text-blue-600"
                                        fill="currentColor"
                                        viewBox="0 0 20 20"
                                      >
                                        <path
                                          fillRule="evenodd"
                                          d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                                          clipRule="evenodd"
                                        />
                                      </svg>
                                    )}
                                  </div>
                                );
                              })}
                            </div>
                          )}
                        </div>

                        {/* Hidden select for form compatibility (optional) */}
                        <select
                          multiple
                          name="additional_equipment"
                          value={selectedEquipment || []}
                          onChange={() => {}} // Handled by custom dropdown
                          className="hidden"
                          tabIndex={-1}
                        >
                          {ADD_EQUIPMENT_OPTIONS.map((option) => (
                            <option key={option.id} value={option.id}>
                              {t(`assets.options.${option.key}`)}
                            </option>
                          ))}
                        </select>

                        {/* Click outside handler */}
                        {isDropdownOpen && (
                          <div
                            className="fixed inset-0 z-0"
                            onClick={() => setIsDropdownOpen(false)}
                          />
                        )}
                      </div>
                    </div>

                    <div className="col-span-1 md:col-span-1 lg:col-span-5">
                      <TextAreaField
                        name="additional_equipment_description"
                        value={newAsset.additional_equipment_description}
                        onChange={handleChange}
                        label={t(
                          "createAsset.placeholders.additonalEquipmentDescription"
                        )}
                        explanation={t(
                          "createAsset.placeholders.additionalEquipmentDescriptionExplanation"
                        )}
                        placeholder={t(
                          "createAsset.placeholders.addtionalEquipmentDescriptionPlaceholder"
                        )}
                      />
                    </div>

                    <div className="col-span-1 md:col-span-1 lg:col-span-5">
                      <TextAreaField
                        name="description"
                        value={newAsset.description}
                        onChange={handleChange}
                        label={t(
                          "createAsset.placeholders.additionalDescription"
                        )}
                        explanation={t(
                          "createAsset.placeholders.cityPlaadditionalDescriptionExplanationceholder"
                        )}
                        placeholder={t(
                          "createAsset.placeholders.additionalDescriptionPlaceholder"
                        )}
                      />
                    </div>

                    <div className="col-span-1 md:col-span-1 lg:col-span-5">
                      <TextAreaField
                        name="engine_description"
                        value={newAsset.engine_description}
                        onChange={handleChange}
                        label={t("createAsset.placeholders.engineDescription")}
                        explanation={t(
                          "createAsset.placeholders.engineDiscriptionExplantion"
                        )}
                        placeholder={t(
                          "createAsset.placeholders.engineDiscriptionPlaceholder"
                        )}
                      />
                    </div>
                  </div>
                </div>

                <div className="bg-white p-6 shadow-md w-full mx-auto ">
                  <h2 className="text-xl font-medium text-gray-800 mb-6">
                    Mast
                  </h2>

                  {/* Mast Type Selection */}
                  <div className="mb-6">
                    <SelectField
                      name="mast_type"
                      value={selectedType}
                      onChange={(e) => {
                        const newType = e.target.value;
                        setSelectedType(newType);
                        setNewAsset((prev) => ({
                          ...prev,
                          mast_type: newType,
                        }));
                      }}
                      label={t("createAsset.placeholders.mastTypeLabel")}
                      explanation={t(
                        "createAsset.placeholders.mastTypeExplanation"
                      )}
                      placeholder={t(
                        "createAsset.placeholders.mastTypePlaceholder"
                      )}
                      menus={[
                        {
                          value: "",
                          option: t(
                            "createAsset.placeholders.mastTypePlaceholder"
                          ),
                        },
                        ...mastTypes.map((type) => ({
                          value: type?.value,
                          option: type?.option,
                        })),
                      ]}
                    />
                  </div>

                  {/* Mast Description */}
                  <div className="mb-2 w-full ">
                    <TextAreaField
                      name="mast_description"
                      value={newAsset.mast_description}
                      onChange={handleChange}
                      label={t("createAsset.placeholders.mastDescription")}
                      explanation={t(
                        "createAsset.placeholders.mastDescriptionPlaceholder"
                      )}
                      placeholder={t(
                        "createAsset.placeholders.mastDescriptionExplanation"
                      )}
                    />
                  </div>

                  {/* Main Grid Container - Responsive CSS Grid Layout */}
                  <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 lg:grid-cols-4 gap-4">
                    {/* Freihub Radio Buttons */}
                    <div className="mb-6 col-span-1 ">
                      <p className="text-sm font-semibold text-gray-700 mb-3">
                        {t("createAsset.placeholders.freihub")}
                      </p>
                      <div className="flex items-center space-x-6">
                        <label className="inline-flex items-center cursor-pointer">
                          <input
                            type="radio"
                            name="freihub"
                            value="true"
                            checked={newAsset.freihub === true}
                            onChange={() => handleRadioChange(true)}
                            className="mr-2 text-blue-500 focus:ring-blue-500"
                          />
                          <span className="text-gray-700">
                            {t("createAsset.placeholders.friehubYes")}
                          </span>
                        </label>
                        <label className="inline-flex items-center cursor-pointer">
                          <input
                            type="radio"
                            name="freihub"
                            value="false"
                            checked={newAsset.freihub === false}
                            onChange={() => handleRadioChange(false)}
                            className="mr-2 text-blue-500 focus:ring-blue-500"
                          />
                          <span className="text-gray-700">
                            {t("createAsset.placeholders.freihubNo")}
                          </span>
                        </label>
                      </div>
                    </div>

                    {/* Forks Description */}
                    <div className="mb-2 col-span-1 md:col-span-1 lg:col-span-1">
                      <InputField
                        name="forks_description"
                        value={newAsset.forks_description}
                        onChange={handleChange}
                        label={t("createAsset.placeholders.forks")}
                        explanation={t(
                          "createAsset.placeholders.forksDescription"
                        )}
                        placeholder={t(
                          "createAsset.placeholders.forksExplanation"
                        )}
                        rows={3}
                      />
                    </div>

                    {/* Fork Carriage */}
                    <div className="mb-2 col-span-1 md:col-span-1 lg:col-span-1">
                      <InputField
                        name="fork_carriage"
                        value={newAsset.fork_carriage}
                        onChange={handleChange}
                        label={t("createAsset.placeholders.forkCarriageLabel")}
                        explanation={t(
                          "createAsset.placeholders.forkCarriageExplanation"
                        )}
                        placeholder={t(
                          "createAsset.placeholders.forkCarriagePlaceholder"
                        )}
                      />
                    </div>

                    {/* Free Height */}
                    <div className="mb-2 col-span-1 md:col-span-1 lg:col-span-1">
                      <InputField
                        type="number"
                        name="free_height"
                        value={newAsset.free_height}
                        maxLength={10}
                        onChange={handleChange}
                        label={t("createAsset.placeholders.forkLengthLabel")}
                        explanation={t(
                          "createAsset.placeholders.forkLengthExplanation"
                        )}
                        placeholder={t(
                          "createAsset.placeholders.forkLengthPlaceholder"
                        )}
                      />
                    </div>
                  </div>

                  {/* Fork Carriage Description - Full Width */}
                  <div className="mt-2">
                    <TextAreaField
                      name="fork_carriage_description"
                      value={newAsset.fork_carriage_description}
                      onChange={handleChange}
                      label={t(
                        "createAsset.placeholders.forkCarrDescriptionLabel"
                      )}
                      explanation={t(
                        "createAsset.placeholders.forkCarrDescriptionExplanation"
                      )}
                      placeholder={t(
                        "createAsset.placeholders.forkCarrDescriptionPlaceholder"
                      )}
                    />
                  </div>

                  {/* Debug: Show current state */}
                </div>

                <div className="bg-white p-4 shadow-md">
                  <h2 className="text-xl font-medium mb-3 text-gray-800">
                    {t("assetPageHeadings.batteryAndCharger")}
                  </h2>

                  <h4 className="mb-3 font-medium">Battery</h4>

                  <div>
                    {/* Battery Row 1: 5 fields - Responsive Grid */}
                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-2 mb-2">
                      <div className="flex flex-col">
                        <InputField
                          label={t(
                            "createAsset.placeholders.batteryManufacturer"
                          )}
                          explanation={t(
                            "createAsset.placeholders.batteryManufacturerExplanation"
                          )}
                          placeholder={t(
                            "createAsset.placeholders.batteryManufacturerPlaceholder"
                          )}
                          maxLength={100}
                          name="battery_manufacturer"
                          value={newAsset.battery_manufacturer}
                          onChange={handleChange}
                        />
                      </div>

                      <div className="flex flex-col">
                        <InputField
                          placeholder={t(
                            "createAsset.placeholders.batteryModelPlaceholder"
                          )}
                          label={t("createAsset.placeholders.batteryModel")}
                          explanation={t(
                            "createAsset.placeholders.batteryModelExplanation"
                          )}
                          type="text"
                          name="batterymodel"
                          value={newAsset.batterymodel}
                          onChange={handleChange}
                          className="p-2 border border-gray-300 gap-2"
                          maxLength={100}
                        />
                      </div>

                      <div className="flex flex-col">
                        <SelectField
                          name="battery_type"
                          value={newAsset.battery_type}
                          onChange={handleChange}
                          label={t("createAsset.placeholders.batteryType")}
                          explanation={t(
                            "createAsset.placeholders.batteryTypeExplanation"
                          )}
                          menus={[
                            {
                              value: "",
                              option: t(
                                "createAsset.placeholders.batteryTypeExplanation"
                              ),
                            },
                            { value: "None", option: t("assets.options.none") },
                            { value: "PzS", option: t("assets.options.pzs") },
                            { value: "Gel", option: t("assets.options.gel") },
                            {
                              value: "Lithium-Ion",
                              option: t("assets.options.lithium-ion"),
                            },
                            {
                              value: "Starter",
                              option: t("assets.options.starter"),
                            },
                            {
                              value: "Waterless",
                              option: t("assets.options.waterless"),
                            },
                            { value: "TPPL", option: t("assets.options.tppl") },
                            { value: "NiMH", option: t("assets.options.nimh") },
                            {
                              value: "Other",
                              option: t("assets.options.battery_others"),
                            },
                          ]}
                        />
                        {/* 
                        <SelectField
                          name="battery_type"
                          value={newAsset.battery_type}
                          onChange={handleChange}
                          label={t("createAsset.placeholders.batteryType")}
                          explanation={t(
                            "createAsset.placeholders.batteryTypeExplanation"
                          )}
                          placeholder={t(
                            "createAsset.placeholders.batteryTypeExplanation"
                          )}
                          menus={[
                            {
                              value: "",
                              option: t(
                                "createAsset.placeholders.batteryTypeExplanation"
                              ),
                            },
                            { value: "none", option: t("assets.options.none") },
                            { value: "pzs", option: t("assets.options.pzs") },
                            { value: "gel", option: t("assets.options.gel") },
                            {
                              value: "lithium-ion",
                              option: t("assets.options.lithium-ion"),
                            },
                            {
                              value: "starter",
                              option: t("assets.options.starter"),
                            },
                            {
                              value: "waterless",
                              option: t("assets.options.waterless"),
                            },
                            { value: "tppl", option: t("assets.options.tppl") }, // Thin Plate Pure Lead
                            { value: "nimh", option: t("assets.options.nimh") },
                            {
                              value: "others",
                              option: t("assets.options.battery_others"),
                            },
                          ]}
                        /> */}
                      </div>

                      <div className="flex flex-col">
                        <SelectField
                          name="battery_voltage"
                          value={newAsset.battery_voltage}
                          onChange={handleChange}
                          label={t(
                            "createAsset.placeholders.batteryNominalVoltage"
                          )}
                          explanation={t(
                            "createAsset.placeholders.batteryNominalVoltageExplanation"
                          )}
                          placeholder={t(
                            "createAsset.placeholders.selectNominalVoltagePlaceholder"
                          )}
                          menus={[
                            {
                              value: "",
                              option: t(
                                "createAsset.placeholders.selectNominalVoltagePlaceholder"
                              ),
                            },
                            { value: "6", option: "6" },
                            { value: "8", option: "8" },
                            { value: "12", option: "12" },
                            { value: "24", option: "24" },
                            { value: "36", option: "36" },
                            { value: "48", option: "48" },
                            { value: "72", option: "72" },
                            { value: "80", option: "80" },
                            { value: "90", option: "90" },
                            { value: "96", option: "96" },
                            { value: "120", option: "120" },
                          ]}
                        />
                      </div>

                      <div className="flex flex-col">
                        <InputField
                          placeholder={t(
                            "createAsset.placeholders.batteryCapacityPlaceholder"
                          )}
                          label={t("createAsset.placeholders.batteryCapacity")}
                          explanation={t(
                            "createAsset.placeholders.batteryCapacityExplanation"
                          )}
                          type="number"
                          name="batterycapacity"
                          value={newAsset.batterycapacity}
                          onChange={handleChange}
                          maxLength={8}
                          className="p-2 border border-gray-300 gap-2"
                        />
                      </div>
                    </div>

                    {/* Battery Row 2: 9 fields with custom spans - Responsive Grid */}
                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 lg:grid-cols-9 gap-2 mb-2">
                      <div className="flex flex-col lg:col-span-2">
                        <InputField
                          placeholder={t(
                            "createAsset.placeholders.batteryYOMPlaceholder"
                          )}
                          label={t(
                            "createAsset.placeholders.batteryYearOfManufacture"
                          )}
                          explanation={t(
                            "createAsset.placeholders.batteryYOMExplanation"
                          )}
                          type="month"
                          name="battery_yom"
                          value={newAsset.battery_yom}
                          onChange={handleChange}
                          className="p-2 border border-gray-300 gap-2"
                        />
                      </div>

                      <div className="flex flex-col lg:col-span-2">
                        <InputField
                          placeholder={t(
                            "createAsset.placeholders.batteryAddtionalEquipmentPlaceholder"
                          )}
                          label={t(
                            "createAsset.placeholders.batteryAdditionalEquipment"
                          )}
                          explanation={t(
                            "createAsset.placeholders.batteryAddtionalEquipmentExplanation"
                          )}
                          type="test"
                          name="battery_additional_equipment"
                          value={newAsset.battery_additional_equipment}
                          onChange={handleChange}
                          className="p-2 border border-gray-300 gap-2"
                        />
                      </div>

                      <div className="flex flex-col">
                        <InputField
                          placeholder={t(
                            "createAsset.placeholders.batteryLengthPlaceholder"
                          )}
                          label={t("createAsset.placeholders.batteryLength")}
                          explanation={t(
                            "createAsset.placeholders.batteryLengthExplanation"
                          )}
                          type="number"
                          name="batterylength"
                          value={newAsset.batterylength}
                          maxLength={8}
                          onChange={handleChange}
                          className="p-2 border border-gray-300 gap-2"
                        />
                      </div>

                      <div className="flex flex-col">
                        <InputField
                          placeholder={t(
                            "createAsset.placeholders.batteryWidthPlaceholder"
                          )}
                          label={t("createAsset.placeholders.batteryWidth")}
                          explanation={t(
                            "createAsset.placeholders.batteryWidthExplanation"
                          )}
                          type="number"
                          name="batterywidth"
                          maxLength={10}
                          value={newAsset.batterywidth}
                          onChange={handleChange}
                          className="p-2 border border-gray-300 gap-2"
                        />
                      </div>

                      <div className="flex flex-col">
                        <InputField
                          placeholder={t(
                            "createAsset.placeholders.batteryWeigthPlaceholder"
                          )}
                          label={t("createAsset.placeholders.batteryWeigth")}
                          explanation={t(
                            "createAsset.placeholders.batteryWeigthExplanation"
                          )}
                          type="number"
                          name="batteryweight"
                          value={newAsset.batteryweight}
                          maxLength={8}
                          onChange={handleChange}
                          className="p-2 border border-gray-300 gap-2"
                        />
                      </div>

                      <div className="flex flex-col">
                        <InputField
                          label={t("createAsset.placeholders.batteryCasing")}
                          placeholder={t(
                            "createAsset.placeholders.batteryCasingPlaceholder"
                          )}
                          type="text"
                          name="batteryCasing"
                          value={newAsset.batteryCasing}
                          onChange={handleChange}
                          className="p-2 border border-gray-300 gap-2"
                        />
                      </div>

                      <div className="flex flex-col">
                        <InputField
                          label={t("createAsset.placeholders.batteryLocation")}
                          explanation={t(
                            "createAsset.placeholders.batteryLocationExplanation"
                          )}
                          type="text"
                          maxLength={50}
                          name="battery_location"
                          value={newAsset.battery_location}
                          onChange={handleChange}
                          placeholder={t(
                            "createAsset.placeholders.batteryLocationPlaceholder"
                          )}
                          className="p-2 border border-gray-300 gap-2"
                        />
                      </div>
                    </div>
                  </div>

                  {/* Charger Information Section */}
                  <div className="bg-white mt-4">
                    <h4 className="font-medium mb-3 text-gray-800">
                      {t("createAsset.placeholders.chargerInformation")}
                    </h4>

                    {/* Charger Row: 7 fields - Responsive Grid */}
                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-7 gap-2 mb-2">
                      <div className="flex flex-col">
                        <InputField
                          label={t(
                            "createAsset.placeholders.chargerManufacturer"
                          )}
                          explanation={t(
                            "createAsset.placeholders.chargerManufacturerExplanation"
                          )}
                          placeholder={t(
                            "createAsset.placeholders.chargerManufacturerPlaceholder"
                          )}
                          type="text"
                          name="chargerManufacturer"
                          value={newAsset.chargerManufacturer}
                          onChange={handleChange}
                          maxLength={100}
                          className="px-4 py-2 border border-gray-300 gap-2-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                        />
                      </div>

                      <div className="flex flex-col">
                        <SelectField
                          name="chargerLoadertype"
                          value={newAsset.chargerLoadertype}
                          onChange={handleChange}
                          label={t("createAsset.placeholders.chargerTypeLabel")}
                          explanation={t(
                            "createAsset.placeholders.chargerTypeExplanation"
                          )}
                          placeholder={t(
                            "createAsset.placeholders.chargerTypePlaceholder"
                          )}
                          menus={[
                            {
                              value: "",
                              option: t(
                                "createAsset.placeholders.chargerTypeExplanation"
                              ),
                            },
                            {
                              value: 1,
                              option: t("assets.options.single-phase"),
                            },
                            {
                              value: 2,
                              option: t("assets.options.three-phase"),
                            },
                            { value: 3, option: t("assets.options.hf") },
                            { value: 4, option: t("assets.options.modular") },
                            {
                              value: 5,
                              option: t("assets.options.opportunity"),
                            },
                            { value: 6, option: t("assets.options.li-ferro") },
                            { value: 7, option: t("assets.options.scr") },
                            {
                              value: 8,
                              option: t("assets.options.charger_others"),
                            },
                          ]}
                        />
                      </div>

                      <div className="flex flex-col">
                        <InputField
                          label={t("createAsset.placeholders.chargerModel")}
                          explanation={t(
                            "createAsset.placeholders.chargerModelExplanation"
                          )}
                          placeholder={t(
                            "createAsset.placeholders.chargerModelPlaceholder"
                          )}
                          type="text"
                          name="chargerModel"
                          value={newAsset.chargerModel}
                          maxLength={100}
                          onChange={handleChange}
                          className="px-4 py-2 border border-gray-300 gap-2-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                        />
                      </div>

                      <div className="flex flex-col">
                        <InputField
                          label={
                            t("createAsset.placeholders.chargerNominalVoltage")
                              .length > 12
                              ? t(
                                  "createAsset.placeholders.chargerNominalVoltage"
                                ).slice(0, 12) + " ..."
                              : t(
                                  "createAsset.placeholders.chargerNominalVoltage"
                                )
                          }
                          explanation={t(
                            "createAsset.placeholders.chargerNominalVoltageExplanation"
                          )}
                          placeholder={t(
                            "createAsset.placeholders.chargerNominalVoltagePlaceholder"
                          )}
                          type="number"
                          name="chargerAC"
                          value={newAsset.chargerAC}
                          onChange={handleChange}
                          className="px-4 py-2 border border-gray-300 gap-2-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                        />
                      </div>

                      <div className="flex flex-col">
                        <InputField
                          label={t("createAsset.placeholders.chargerAMP")}
                          explanation={t(
                            "createAsset.placeholders.chargerAMPExplanation"
                          )}
                          placeholder={t(
                            "createAsset.placeholders.chargerAMPPlaceholder"
                          )}
                          type="number"
                          name="chargerCurrent"
                          value={newAsset.chargerCurrent}
                          onChange={handleChange}
                          className="px-4 py-2 border border-gray-300 gap-2-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                        />
                      </div>

                      <div className="flex flex-col">
                        <InputField
                          label={
                            t("createAsset.placeholders.chargerACVoltage")
                              .length > 12
                              ? t(
                                  "createAsset.placeholders.chargerACVoltage"
                                ).slice(0, 12) + " ..."
                              : t("createAsset.placeholders.chargerACVoltage")
                          }
                          explanation={t(
                            "createAsset.placeholders.chargerACVoltageExplanation"
                          )}
                          placeholder={t(
                            "createAsset.placeholders.chargerACVoltagePlaceholder"
                          )}
                          type="number"
                          name="chargerVoltage"
                          value={newAsset.chargerVoltage}
                          maxLength={50}
                          onChange={handleChange}
                          className="px-4 py-2 border border-gray-300 gap-2-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                        />
                      </div>

                      <div className="flex flex-col">
                        <InputField
                          label={
                            t("createAsset.placeholders.chargerYOM").length > 12
                              ? t("createAsset.placeholders.chargerYOM").slice(
                                  0,
                                  12
                                ) + " ..."
                              : t("createAsset.placeholders.chargerYOM")
                          }
                          explanation={t(
                            "createAsset.placeholders.chargerYOMExplanation"
                          )}
                          placeholder={t(
                            "createAsset.placeholders.chargerYOMPlaceholder"
                          )}
                          type="month"
                          name="charger_yom"
                          value={newAsset.charger_yom?.slice(0, 7)}
                          onChange={handleChange}
                          className="px-4 py-2 border border-gray-300 gap-2-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                        />
                      </div>
                    </div>

                    {/* Battery Description (spans full width) */}
                    <div className="mb-6">
                      <TextAreaField
                        name="battery_description"
                        value={newAsset.battery_description}
                        onChange={handleChange}
                        label={t("createAsset.placeholders.batteryDescription")}
                        explanation={t(
                          "createAsset.placeholders.batteryDescriptionPlaceholder"
                        )}
                        placeholder={t(
                          "createAsset.placeholders.batteryDescriptionExplanation"
                        )}
                      />
                    </div>
                  </div>
                </div>

                <div className="bg-white p-4 shadow-md">
                  <h3 className="text-lg font-semibold text-gray-800 mb-6">
                    {t("assetPageHeadings.tires")}
                  </h3>

                  {/* Tires Grid - Responsive Layout */}
                  <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-2">
                    <div>
                      <SelectField
                        name="tire_type"
                        value={newAsset.tire_type}
                        onChange={handleChange}
                        label={t("createAsset.placeholders.tireType")}
                        explanation={t(
                          "createAsset.placeholders.tireTypeExplanation"
                        )}
                        menus={[
                          {
                            value: "",
                            option: t("assets.fields.selectTireType"),
                          },
                          { value: 1, option: t("assets.options.cushion") },
                          { value: 2, option: t("assets.options.pneumatic") },
                          {
                            value: 3,
                            option: t("assets.options.polyurethane"),
                          },
                          {
                            value: 4,
                            option: t("assets.options.superelastic"),
                          },
                          { value: 5, option: t("assets.options.solid") },
                          { value: 6, option: t("assets.options.vulkollan") },
                        ]}
                      />
                    </div>

                    <div>
                      <InputField
                        name="front_tires"
                        type="number"
                        value={newAsset.front_tires}
                        onChange={handleChange}
                        maxLength={50}
                        label={t("createAsset.placeholders.frontTires")}
                        explanation={t(
                          "createAsset.placeholders.frontTiresExplanation"
                        )}
                        placeholder={t(
                          "createAsset.placeholders.fronteTiresPlaceholder"
                        )}
                      />
                    </div>

                    <div>
                      <InputField
                        name="front_tire_size"
                        type="number"
                        value={newAsset.front_tire_size}
                        onChange={handleChange}
                        maxLength={50}
                        label={t("createAsset.placeholders.frontTireSize")}
                        explanation={t(
                          "createAsset.placeholders.frontTireSizePlaceholder"
                        )}
                        placeholder={t(
                          "createAsset.placeholders.frontTireSizeExplanation"
                        )}
                      />
                    </div>

                    <div>
                      <InputField
                        name="rear_tires"
                        type="number"
                        value={newAsset.rear_tires}
                        onChange={handleChange}
                        maxLength={50}
                        label={t("createAsset.placeholders.rearTires")}
                        explanation={t(
                          "createAsset.placeholders.rearTiresExplanation"
                        )}
                        placeholder={t(
                          "createAsset.placeholders.rearTiresPlaceholder"
                        )}
                      />
                    </div>

                    <div>
                      <InputField
                        name="rear_tire_size"
                        type="number"
                        value={newAsset.rear_tire_size}
                        onChange={handleChange}
                        maxLength={50}
                        label={t("createAsset.placeholders.rearTireSize")}
                        explanation={t(
                          "createAsset.placeholders.rearTireSizePlaceholder"
                        )}
                        placeholder={t(
                          "createAsset.placeholders.rearTireSizeExplanation"
                        )}
                      />
                    </div>
                  </div>

                  {/* Tire Description - Full Width */}
                  <div className="mt-4">
                    <TextAreaField
                      name="tire_description"
                      value={newAsset.tire_description}
                      onChange={handleChange}
                      label={t("createAsset.placeholders.tireDescription")}
                      explanation={t(
                        "createAsset.placeholders.tireDescriptionExplanation"
                      )}
                      placeholder={t(
                        "createAsset.placeholders.tireDescriptionPlaceholder"
                      )}
                    />
                  </div>
                </div>

                <div className="bg-white p-4 shadow-md ">
                  <h2 className="text-xl font-medium mb-3  text-gray-800">
                    {t("assetPageHeadings.media")}
                  </h2>

                  {selectedFiles?.length > 0 && (
                    <div className="space-y-2">
                      {/* <h4 className=" text-gray-700">Selected Files</h4> */}
                      <h6 className="mb-2">
                        {t("assetPageHeadings.selectedMedia")}{" "}
                      </h6>
                      <ul className="space-y-1 flex flex-col gap-3">
                        {Array.from(selectedFiles).map((file, index) => (
                          <li key={index} className="flex items-center gap-4">
                            {file.type.startsWith("image/") && (
                              <img
                                className="h-10 w-10"
                                alt={`asset image  ${index}`}
                                src={URL.createObjectURL(file)}
                              />
                            )}
                            <a
                              href={URL.createObjectURL(file)}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="text-blue-600 text-sm font-semibold underline "
                            >
                              {file.name}
                            </a>
                            <div
                              onClick={() => handleRemoveFile(index)}
                              className="cursor-pointer"
                            >
                              <X className="h-5 w-5 " />
                            </div>
                          </li>
                        ))}
                      </ul>
                    </div>
                  )}

                  <div className="my-4">
                    <div className="relative">
                      <input
                        type="file"
                        multiple
                        onChange={handleFileChange}
                        accept="image/*, .xlsx, .xls, .doc, .docx, .pdf, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/msword, application/pdf"
                        className="absolute inset-0 w-full h-full opacity-0 cursor-pointer z-10"
                        id="image-upload"
                      />
                      <label
                        htmlFor="image-upload"
                        className="flex flex-col items-center justify-center w-full h-32 border-2 border-dashed border-gray-300 rounded-lg cursor-pointer bg-gray-50 hover:bg-gray-100 hover:border-gray-400 transition-all duration-200 ease-in-out group"
                      >
                        <div className="flex flex-col items-center justify-center pt-5 pb-6">
                          <div className="flex items-center space-x-2 mb-2">
                            <Upload className="w-6 h-6 text-gray-400 group-hover:text-gray-600 transition-colors" />
                            <ImagePlus className="w-6 h-6 text-gray-400 group-hover:text-gray-600 transition-colors" />
                          </div>
                          <p className="mb-2 text-sm text-gray-500 group-hover:text-gray-700 transition-colors">
                            <span className="font-semibold">
                              {t("assetPageHeadings.clickToUpload")}
                            </span>
                          </p>
                          <p className="text-xs text-gray-400 group-hover:text-gray-600 transition-colors">
                            {t("assetPageHeadings.fileSupported")}
                          </p>
                        </div>
                      </label>
                      {fileSizeError && (
                        <div className="text-red-500 text-sm mt-2">
                          {fileSizeError}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            )}

            {selectedCategory === "Attachments" && (
              <Attachments
                newAsset={newAsset}
                handleChange={handleChange}
                warehouses={warehouses}
                selectedWarehouse={selectedWarehouse}
                handleWarehouseChange={handleWarehouseChange}
                selectedFiles={selectedFiles}
                handleRemoveFile={handleRemoveFile}
                handleFileChange={handleFileChange}
              />
            )}
            {selectedCategory === "Lift Masts" && (
              <LiftMasts
                newAsset={newAsset}
                handleChange={handleChange}
                warehouses={warehouses}
                selectedWarehouse={selectedWarehouse}
                handleWarehouseChange={handleWarehouseChange}
                selectedFiles={selectedFiles}
                handleRemoveFile={handleRemoveFile}
                handleFileChange={handleFileChange}
              />
            )}
            {selectedCategory === "Work Platforms" && (
              <WorkPlatforms
                newAsset={newAsset}
                handleChange={handleChange}
                warehouses={warehouses}
                selectedWarehouse={selectedWarehouse}
                handleWarehouseChange={handleWarehouseChange}
                selectedFiles={selectedFiles}
                handleRemoveFile={handleRemoveFile}
                handleFileChange={handleFileChange}
              />
            )}
            {selectedCategory === "Cleaning Equipment" && (
              <CleaningEquipment
                newAsset={newAsset}
                handleChange={handleChange}
                warehouses={warehouses}
                selectedWarehouse={selectedWarehouse}
                handleWarehouseChange={handleWarehouseChange}
                selectedFiles={selectedFiles}
                handleRemoveFile={handleRemoveFile}
                handleFileChange={handleFileChange}
              />
            )}
            {selectedCategory === "Spare Parts" && (
              <SpareParts
                newAsset={newAsset}
                handleChange={handleChange}
                warehouses={warehouses}
                selectedWarehouse={selectedWarehouse}
                handleWarehouseChange={handleWarehouseChange}
                selectedFiles={selectedFiles}
                handleRemoveFile={handleRemoveFile}
                handleFileChange={handleFileChange}
              />
            )}
            {selectedCategory === "Construction Machinery" && (
              <ConstructionMachinery
                newAsset={newAsset}
                handleChange={handleChange}
                warehouses={warehouses}
                selectedWarehouse={selectedWarehouse}
                handleWarehouseChange={handleWarehouseChange}
                selectedFiles={selectedFiles}
                handleRemoveFile={handleRemoveFile}
                handleFileChange={handleFileChange}
              />
            )}
          </>
        )}
        {currentStep === 1 && (
          <>
            <AssetFormButtonGroup
              t={t}
              isLoading={isLoading}
              navigate={navigate}
            />

            {(selectedCategory === "Forklifts" ||
              selectedCategory === "Chargers") && (
              <>
                {/* Pricing Information Section */}
                <div className="mb-6 bg-white p-4 shadow-md">
                  <h3 className="text-lg font-semibold text-gray-700 mb-4">
                    {t("assetPageHeadings.pricingInformation")}
                  </h3>

                  {/* Main Pricing Grid - Responsive Layout */}
                  <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-3">
                    <div>
                      <InputField
                        name="end_user_price"
                        type="number"
                        step="0.01"
                        value={newAsset.end_user_price}
                        onChange={handleChange}
                        label={t("createAsset.placeholders.endUserPriceLabel")}
                        explanation={t(
                          "createAsset.placeholders.endUserPriceExplanation"
                        )}
                        placeholder={t(
                          "createAsset.placeholders.endUserPricePlaceholder"
                        )}
                        maxLength={12}
                      />
                    </div>

                    <div>
                      <InputField
                        name="dealer_price"
                        type="number"
                        step="0.01"
                        value={newAsset.dealer_price}
                        onChange={handleChange}
                        label={t("createAsset.placeholders.dealerPriceLabel")}
                        explanation={t(
                          "createAsset.placeholders.dealerPriceExplanation"
                        )}
                        placeholder={t(
                          "createAsset.placeholders.dealerPricePlaceholder"
                        )}
                        maxLength={12}
                      />
                    </div>

                    <div>
                      <InputField
                        name="internal_price"
                        type="number"
                        step="0.01"
                        value={newAsset.internal_price}
                        onChange={handleChange}
                        label={t("createAsset.placeholders.internalPriceLabel")}
                        explanation={t(
                          "createAsset.placeholders.internalPriceExplanation"
                        )}
                        placeholder={t(
                          "createAsset.placeholders.internalPricePlaceholder"
                        )}
                        maxLength={12}
                      />
                    </div>

                    {/* Publish To Section - Spans 2 columns on large screens */}
                    <div className="col-span-1 sm:col-span-2 md:col-span-3 lg:col-span-2 flex flex-col sm:flex-row sm:items-center sm:space-x-4 space-y-2 sm:space-y-0 w-full">
                      <span className="text-sm font-medium text-gray-700">
                        {t("createAsset.placeholders.publishTo")}
                      </span>

                      <div className="flex flex-col sm:flex-row space-y-2 sm:space-y-0 sm:space-x-4">
                        <label className="flex items-center space-x-1">
                          <input
                            type="checkbox"
                            name="publish_mascus"
                            checked={newAsset.publish_mascus || false}
                            onChange={handleChange}
                            className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                          />
                          <span className="text-sm text-gray-700">Mascus</span>
                        </label>

                        <label className="flex items-center space-x-1">
                          <input
                            type="checkbox"
                            name="publish_supralift"
                            checked={newAsset.publish_supralift || false}
                            onChange={handleChange}
                            className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                          />
                          <span className="text-sm text-gray-700">
                            Supralift
                          </span>
                        </label>

                        <label className="flex items-center space-x-1">
                          <input
                            type="checkbox"
                            name="publish_forklift"
                            checked={newAsset.publish_forklift || false}
                            onChange={handleChange}
                            className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                          />
                          <span className="text-sm text-gray-700">
                            Forklift
                          </span>
                        </label>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Rental Pricing Section */}
                <div className="mb-8 bg-white p-4 shadow-md">
                  <h4 className="text-md font-medium text-gray-700 mb-4">
                    {t("assetPageHeadings.rentingPriceInformation")}
                  </h4>

                  {/* Rental Pricing Grid - Responsive Layout */}
                  <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-3 gap-3">
                    <div>
                      <InputField
                        name="rental_price_daily"
                        type="number"
                        step="0.01"
                        value={newAsset.rental_price_daily}
                        onChange={handleChange}
                        label={t(
                          "createAsset.placeholders.rentalPriceDailyLabel"
                        )}
                        explanation={t(
                          "createAsset.placeholders.rentalPriceDailyExplanation"
                        )}
                        placeholder={t(
                          "createAsset.placeholders.rentalPriceDailyPlaceholder"
                        )}
                        maxLength={12}
                      />
                    </div>

                    <div>
                      <InputField
                        name="rental_price_weekly"
                        type="number"
                        step="0.01"
                        value={newAsset.rental_price_weekly}
                        onChange={handleChange}
                        label={t(
                          "createAsset.placeholders.rentalPriceWeeklyLabel"
                        )}
                        explanation={t(
                          "createAsset.placeholders.rentalPriceWeeklyExplanation"
                        )}
                        placeholder={t(
                          "createAsset.placeholders.rentalPriceWeeklyPlaceholder"
                        )}
                        maxLength={12}
                      />
                    </div>

                    <div>
                      <InputField
                        name="rental_price_monthly"
                        type="number"
                        step="0.01"
                        value={newAsset.rental_price_monthly}
                        onChange={handleChange}
                        label={t(
                          "createAsset.placeholders.rentalPriceMonthlyLabel"
                        )}
                        explanation={t(
                          "createAsset.placeholders.rentalPriceMonthlyExplanation"
                        )}
                        placeholder={t(
                          "createAsset.placeholders.rentalPriceMonthlyPlaceholder"
                        )}
                        maxLength={12}
                      />
                    </div>
                  </div>
                </div>

                {/* Purchase Information Section */}
                <div className="mb-8 bg-white p-4 shadow-md">
                  <h4 className="text-md font-medium text-gray-700 mb-4">
                    {t("createAsset.placeholders.purchaseInformation")}
                  </h4>

                  {/* Purchase Information Grid - Responsive Layout */}
                  <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-3 gap-3">
                    <div>
                      <InputField
                        name="purchase_price"
                        type="number"
                        step="0.01"
                        value={newAsset.purchase_price}
                        onChange={handleChange}
                        label={t("createAsset.placeholders.purchasePriceLabel")}
                        explanation={t(
                          "createAsset.placeholders.purchasePriceExplanation"
                        )}
                        placeholder={t(
                          "createAsset.placeholders.purchasePricePlaceholder"
                        )}
                        maxLength={12}
                      />
                    </div>

                    <div>
                      <InputField
                        name="purchase_date"
                        type="date"
                        value={newAsset.purchase_date || ""}
                        onChange={handleChange}
                        label={t(
                          "createAsset.placeholders.dateOfPurchaseLabel"
                        )}
                        explanation={t(
                          "createAsset.placeholders.dateOfPurchaseExplanation"
                        )}
                      />
                    </div>

                    <div>
                      <InputField
                        name="book_value"
                        type="number"
                        step="0.01"
                        value={newAsset.book_value}
                        onChange={handleChange}
                        label={t("createAsset.placeholders.bookValueLabel")}
                        explanation={t(
                          "createAsset.placeholders.bookValueExplanation"
                        )}
                        placeholder={t(
                          "createAsset.placeholders.bookValuePlaceholder"
                        )}
                        maxLength={12}
                      />
                    </div>
                  </div>
                </div>

                <BookValueHistory t={t} />

                {/* Remarks Section */}
                <div className="mb-8 bg-white p-4 shadow-md">
                  <h4 className="text-md font-medium text-gray-700 mb-4">
                    {t("createAsset.placeholders.Remarks")}
                  </h4>

                  {/* Remarks Grid - Responsive Layout */}
                  <div className="grid grid-cols-1 lg:grid-cols-2 gap-3">
                    <div className="mb-2">
                      <label className="block text-sm font-medium text-gray-700 mb-1">
                        {t("createAsset.placeholders.internalRemark")}
                      </label>
                      <textarea
                        name="internal_remark"
                        value={newAsset.internal_remark || ""}
                        onChange={handleChange}
                        rows={4}
                        className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 resize-vertical"
                        placeholder={t(
                          "createAsset.placeholders.internalRemarkPlaceholder"
                        )}
                      />
                      <p className="text-xs text-gray-500 mt-1">
                        {t("createAsset.placeholders.internalRemarkForAsset")}
                      </p>
                    </div>

                    <div className="mb-2">
                      <label className="block text-sm font-medium text-gray-700 mb-1">
                        {t("createAsset.placeholders.intranetRemarks")}
                      </label>
                      <textarea
                        name="intranet_remark"
                        value={newAsset.intranet_remark || ""}
                        onChange={handleChange}
                        rows={4}
                        className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 resize-vertical"
                        placeholder={t(
                          "createAsset.placeholders.intranetRemarksPlaceholder"
                        )}
                      />
                      <p className="text-xs text-gray-500 mt-1">
                        {t("createAsset.placeholders.intranetRemarksForAsset")}
                      </p>
                    </div>
                  </div>
                </div>
              </>
            )}
            {selectedCategory === "Batteries" && (
              <>
                <div className="mb-6 bg-white p-4 shadow-md">
                  <h3 className="text-lg font-semibold  text-gray-700 mb-4">
                    {t("assetPageHeadings.pricingInformation")}
                  </h3>
                  <div className="grid grid-cols-1 sm:grid-cols-4 lg:grid-cols-5 gap-3">
                    <div>
                      <InputField
                        name="end_user_price"
                        type="number"
                        step="0.01"
                        value={newAsset.end_user_price}
                        onChange={handleChange}
                        label={t("createAsset.placeholders.endUserPriceLabel")}
                        explanation={t(
                          "createAsset.placeholders.endUserPriceExplanation"
                        )}
                        placeholder={t(
                          "createAsset.placeholders.endUserPricePlaceholder"
                        )}
                        maxLength={12}
                      />
                    </div>
                    <div>
                      <InputField
                        name="dealer_price"
                        type="number"
                        step="0.01"
                        value={newAsset.dealer_price}
                        onChange={handleChange}
                        label={t("createAsset.placeholders.dealerPriceLabel")}
                        explanation={t(
                          "createAsset.placeholders.dealerPriceExplanation"
                        )}
                        placeholder={t(
                          "createAsset.placeholders.dealerPricePlaceholder"
                        )}
                        maxLength={12}
                      />
                    </div>
                    <div>
                      <InputField
                        name="internal_price"
                        type="number"
                        step="0.01"
                        value={newAsset.internal_price}
                        onChange={handleChange}
                        label={t("createAsset.placeholders.internalPriceLabel")}
                        explanation={t(
                          "createAsset.placeholders.internalPriceExplanation"
                        )}
                        placeholder={t(
                          "createAsset.placeholders.internalPricePlaceholder"
                        )}
                        maxLength={12}
                      />
                    </div>

                    <div className="col-span-2 flex items-center space-x-4  w-full ">
                      <span className="text-sm font-medium text-gray-700">
                        {t("createAsset.placeholders.publishTo")}
                      </span>

                      <label className="flex items-center space-x-1">
                        <input
                          type="checkbox"
                          name="publish_mascus"
                          checked={newAsset.publish_mascus || false}
                          onChange={handleChange}
                          className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                        />
                        <span className="text-sm text-gray-700">Mascus</span>
                      </label>

                      <label className="flex items-center space-x-1">
                        <input
                          type="checkbox"
                          name="publish_supralift"
                          checked={newAsset.publish_supralift || false}
                          onChange={handleChange}
                          className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                        />
                        <span className="text-sm text-gray-700">Supralift</span>
                      </label>

                      <label className="flex items-center space-x-1">
                        <input
                          type="checkbox"
                          name="publish_forklift"
                          checked={newAsset.publish_forklift || false}
                          onChange={handleChange}
                          className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                        />
                        <span className="text-sm text-gray-700">Forklift</span>
                      </label>
                    </div>
                  </div>
                </div>
                {/* Rental Pricing Section */}
                <div className="mb-8 bg-white p-4 shadow-md">
                  <h4 className="text-md font-medium text-gray-700 mb-4">
                    {t("assetPageHeadings.rentingPriceInformation")}
                  </h4>

                  {/* Rental Pricing Grid - Responsive Layout */}
                  <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-3 gap-3">
                    <div>
                      <InputField
                        name="rental_price_daily"
                        type="number"
                        step="0.01"
                        value={newAsset.rental_price_daily}
                        onChange={handleChange}
                        label={t(
                          "createAsset.placeholders.rentalPriceDailyLabel"
                        )}
                        explanation={t(
                          "createAsset.placeholders.rentalPriceDailyExplanation"
                        )}
                        placeholder={t(
                          "createAsset.placeholders.rentalPriceDailyPlaceholder"
                        )}
                        maxLength={12}
                      />
                    </div>

                    <div>
                      <InputField
                        name="rental_price_weekly"
                        type="number"
                        step="0.01"
                        value={newAsset.rental_price_weekly}
                        onChange={handleChange}
                        label={t(
                          "createAsset.placeholders.rentalPriceWeeklyLabel"
                        )}
                        explanation={t(
                          "createAsset.placeholders.rentalPriceWeeklyExplanation"
                        )}
                        placeholder={t(
                          "createAsset.placeholders.rentalPriceWeeklyPlaceholder"
                        )}
                        maxLength={12}
                      />
                    </div>

                    <div>
                      <InputField
                        name="rental_price_monthly"
                        type="number"
                        step="0.01"
                        value={newAsset.rental_price_monthly}
                        onChange={handleChange}
                        label={t(
                          "createAsset.placeholders.rentalPriceMonthlyLabel"
                        )}
                        explanation={t(
                          "createAsset.placeholders.rentalPriceMonthlyExplanation"
                        )}
                        placeholder={t(
                          "createAsset.placeholders.rentalPriceMonthlyPlaceholder"
                        )}
                        maxLength={12}
                      />
                    </div>
                  </div>
                </div>

                {/* Purchase Information Section */}
                <div className="mb-8 bg-white p-4 shadow-md">
                  <h4 className="text-md font-medium text-gray-700 mb-4">
                    {t("createAsset.placeholders.purchaseInformation")}
                  </h4>

                  {/* Purchase Information Grid - Responsive Layout */}
                  <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-3 gap-3">
                    <div>
                      <InputField
                        name="purchase_price"
                        type="number"
                        step="0.01"
                        value={newAsset.purchase_price}
                        onChange={handleChange}
                        label={t("createAsset.placeholders.purchasePriceLabel")}
                        explanation={t(
                          "createAsset.placeholders.purchasePriceExplanation"
                        )}
                        placeholder={t(
                          "createAsset.placeholders.purchasePricePlaceholder"
                        )}
                        maxLength={12}
                      />
                    </div>

                    <div>
                      <InputField
                        name="purchase_date"
                        type="date"
                        value={newAsset.purchase_date || ""}
                        onChange={handleChange}
                        label={t(
                          "createAsset.placeholders.dateOfPurchaseLabel"
                        )}
                        explanation={t(
                          "createAsset.placeholders.dateOfPurchaseExplanation"
                        )}
                      />
                    </div>

                    <div>
                      <InputField
                        name="book_value"
                        type="number"
                        step="0.01"
                        value={newAsset.book_value}
                        onChange={handleChange}
                        label={t("createAsset.placeholders.bookValueLabel")}
                        explanation={t(
                          "createAsset.placeholders.bookValueExplanation"
                        )}
                        placeholder={t(
                          "createAsset.placeholders.bookValuePlaceholder"
                        )}
                        maxLength={12}
                      />
                    </div>
                  </div>
                </div>

                <BookValueHistory t={t} />

                {/* Remarks Section */}
                <div className="mb-8 bg-white p-4 shadow-md">
                  <h4 className="text-md font-medium text-gray-700 mb-4">
                    {t("createAsset.placeholders.Remarks")}
                  </h4>

                  {/* Remarks Grid - Responsive Layout */}
                  <div className="grid grid-cols-1 lg:grid-cols-2 gap-3">
                    <div className="mb-2">
                      <label className="block text-sm font-medium text-gray-700 mb-1">
                        {t("createAsset.placeholders.internalRemark")}
                      </label>
                      <textarea
                        name="internal_remark"
                        value={newAsset.internal_remark || ""}
                        onChange={handleChange}
                        rows={4}
                        className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 resize-vertical"
                        placeholder={t(
                          "createAsset.placeholders.internalRemarkPlaceholder"
                        )}
                      />
                      <p className="text-xs text-gray-500 mt-1">
                        {t("createAsset.placeholders.internalRemarkForAsset")}
                      </p>
                    </div>

                    <div className="mb-2">
                      <label className="block text-sm font-medium text-gray-700 mb-1">
                        {t("createAsset.placeholders.intranetRemarks")}
                      </label>
                      <textarea
                        name="intranet_remark"
                        value={newAsset.intranet_remark || ""}
                        onChange={handleChange}
                        rows={4}
                        className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 resize-vertical"
                        placeholder={t(
                          "createAsset.placeholders.intranetRemarksPlaceholder"
                        )}
                      />
                      <p className="text-xs text-gray-500 mt-1">
                        {t("createAsset.placeholders.intranetRemarksForAsset")}
                      </p>
                    </div>
                  </div>
                </div>
              </>
            )}
            {selectedCategory === "Attachments" && (
              <FinancialInfoSection
                t={t}
                newAsset={newAsset}
                handleChange={handleChange}
              />
            )}
            {selectedCategory === "Lift Masts" && (
              <FinancialInfoSection
                t={t}
                newAsset={newAsset}
                handleChange={handleChange}
              />
            )}
            {selectedCategory === "Work Platforms" && (
              <FinancialInfoSection
                t={t}
                newAsset={newAsset}
                handleChange={handleChange}
              />
            )}
            {selectedCategory === "Cleaning Equipment" && (
              <FinancialInfoSection
                t={t}
                newAsset={newAsset}
                handleChange={handleChange}
              />
            )}
            {selectedCategory === "Spare Parts" && (
              <FinancialInfoSection
                t={t}
                newAsset={newAsset}
                handleChange={handleChange}
              />
            )}
            {selectedCategory === "Construction Machinery" && (
              <FinancialInfoSection
                t={t}
                newAsset={newAsset}
                handleChange={handleChange}
              />
            )}
          </>
        )}

        {currentStep === 2 && (
          <>
            <AssetFormButtonGroup
              t={t}
              isLoading={isLoading}
              navigate={navigate}
            />

            {(selectedCategory === "Forklifts" ||
              selectedCategory === "Chargers") && (
              <div className="mb-8 ">
                <div className="mb-6 bg-white p-4 shadow-md">
                  <h4 className="text-md font-medium mb-3 text-gray-700">
                    {t("assetPageHeadings.contractInformation")}
                  </h4>

                  {/* Contract Details Row */}
                  <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-4 gap-x-2 mb-2">
                    <div>
                      <SelectField
                        name="contract_type"
                        value={newAsset?.contracts[0]?.contract_type}
                        onChange={handleChange}
                        label={t("createAsset.placeholders.contractLabel")}
                        explanation={t(
                          "createAsset.placeholders.contractExplanation"
                        )}
                        required
                        menus={[
                          {
                            value: "",
                            option: t(
                              "createAsset.placeholders.contractExplanation"
                            ),
                          },
                          { value: "demo", option: t("assets.options.demo") },
                          {
                            value: "rental",
                            option: t("assets.options.rental"),
                          },
                          {
                            value: "leasing",
                            option: t("assets.options.leasing"),
                          },
                          { value: "sale", option: t("assets.options.sale") },
                          {
                            value: "maintenance",
                            option: t("assets.options.maintenance"),
                          },
                        ]}
                      />
                    </div>
                    <div>
                      <InputField
                        name="contract_start"
                        type="date"
                        value={newAsset.contracts[0].contract_start}
                        onChange={handleChange}
                        label={t("createAsset.placeholders.contractStartLabel")}
                        explanation={t(
                          "createAsset.placeholders.contractStartExplanation"
                        )}
                      />
                    </div>
                    <div>
                      <InputField
                        name="contract_end"
                        type="date"
                        value={newAsset.contracts[0].contract_end}
                        onChange={handleChange}
                        label={t("createAsset.placeholders.contractEndLabel")}
                        explanation={t(
                          "createAsset.placeholders.contractEndExplanation"
                        )}
                      />
                    </div>
                    <div>
                      <InputField
                        name="contract_price_euro"
                        type="number"
                        step="0.01"
                        min="0"
                        value={newAsset.contracts[0].contract_price_euro}
                        onChange={handleChange}
                        maxLength={12}
                        label={t("createAsset.placeholders.contractPrice")}
                        placeholder={t(
                          "createAsset.placeholders.contractPricePlaceholder"
                        )}
                        explanation={t(
                          "createAsset.placeholders.contractPriceExplanation"
                        )}
                      />
                    </div>
                  </div>

                  {/* Customer Contact Information Row */}
                  <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-x-2 mb-2">
                    <div>
                      <InputField
                        name="customer_company"
                        required
                        type="text"
                        maxLength={50}
                        value={newAsset.contracts[0].customer.customer_company}
                        onChange={handleChange}
                        placeholder={t(
                          "createAsset.placeholders.companyPlaceholder"
                        )}
                        label={t("createAsset.placeholders.companyLabel")}
                        explanation={t(
                          "createAsset.placeholders.companyExplanation"
                        )}
                      />
                    </div>
                    <div>
                      <InputField
                        name="name"
                        required
                        type="text"
                        maxLength={50}
                        value={newAsset.contracts[0].customer.name}
                        onChange={handleChange}
                        placeholder={t(
                          "createAsset.placeholders.contactPersonPlaceholder"
                        )}
                        label={t("createAsset.placeholders.contactPersonLabel")}
                        explanation={t(
                          "createAsset.placeholders.contactPersonExplanation"
                        )}
                      />
                    </div>
                    <div>
                      <InputField
                        name="phone_number"
                        required
                        type="tel"
                        maxLength={20}
                        value={newAsset.contracts[0].customer.phone_number}
                        onChange={handleChange}
                        placeholder={t(
                          "createAsset.placeholders.phonePlaceholder"
                        )}
                        label={t("createAsset.placeholders.phoneLabel")}
                        explanation={t(
                          "createAsset.placeholders.phoneExplanation"
                        )}
                      />
                    </div>
                    <div>
                      <InputField
                        name="email"
                        type="email"
                        maxLength={100}
                        value={newAsset.contracts[0].customer.email}
                        onChange={handleChange}
                        placeholder={t(
                          "createAsset.placeholders.emailPlaceholder"
                        )}
                        label={t("createAsset.placeholders.emailLabel")}
                        explanation={t(
                          "createAsset.placeholders.emailExplanation"
                        )}
                      />
                    </div>
                    <div>
                      <InputField
                        name="customer_number"
                        type="text"
                        maxLength={20}
                        value={newAsset.contracts[0].customer.customer_number}
                        onChange={handleChange}
                        placeholder={t(
                          "createAsset.placeholders.customerNumberPlaceholder"
                        )}
                        label={t(
                          "createAsset.placeholders.customerNumberLabel"
                        )}
                        explanation={t(
                          "createAsset.placeholders.customerNumberExplanation"
                        )}
                      />
                    </div>
                  </div>

                  {/* Invoice Address Section */}
                  <div className="mb-4">
                    <h5 className="text-sm font-medium mb-2 text-gray-600">
                      {t("createAsset.placeholders.InvoiceAddress")}
                    </h5>
                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-x-2">
                      {Array.isArray(warehouses) && warehouses?.length > 0 && (
                        <div className="col-span-1 sm:col-span-2 md:col-span-2 lg:col-span-2">
                          <SelectField
                            name="warehouse"
                            value={selectedContractWarehouse?.id || ""}
                            onChange={(e) => {
                              handleWarehouseChange2(e);
                            }}
                            label={t("createAsset.placeholders.warehouseLabel")}
                            explanation={t(
                              "createAsset.placeholders.warehouseExplanation"
                            )}
                            placeholder={t(
                              "createAsset.placeholders.warehousePlaceholder"
                            )}
                            menus={[
                              {
                                value: "",
                                option: t(
                                  "createAsset.placeholders.warehousePlaceholder"
                                ),
                              },
                              ...warehouses.map((warehouse) => {
                                return {
                                  value: warehouse.id,
                                  option: warehouse.name,
                                };
                              }),
                            ]}
                          />
                        </div>
                      )}
                      <div>
                        <InputField
                          name="invoice_address_street"
                          type="text"
                          maxLength={20}
                          value={newAsset.contracts[0].invoice_address_street}
                          onChange={handleChange}
                          placeholder={t(
                            "createAsset.placeholders.streetPlaceholder"
                          )}
                          label={t("createAsset.placeholders.streetLabel")}
                          explanation={t(
                            "createAsset.placeholders.streetExplanation"
                          )}
                        />
                      </div>

                      <div>
                        <InputField
                          name="invoice_address_city"
                          type="text"
                          maxLength={20}
                          // newAsset.contracts[0].contract_start
                          value={newAsset.contracts[0].invoice_address_city}
                          onChange={handleChange}
                          placeholder={t(
                            "createAsset.placeholders.cityPlaceholder"
                          )}
                          label={t("createAsset.placeholders.cityLabel")}
                          explanation={t(
                            "createAsset.placeholders.cityExplanation"
                          )}
                        />
                      </div>
                      <div>
                        <InputField
                          name="invoice_address_country"
                          type="text"
                          maxLength={20}
                          value={newAsset.contracts[0].invoice_address_country}
                          onChange={handleChange}
                          placeholder={t(
                            "createAsset.placeholders.countryPlaceholder"
                          )}
                          label={t("createAsset.placeholders.countryLabel")}
                          explanation={t(
                            "createAsset.placeholders.countryExplanation"
                          )}
                        />
                      </div>

                      <div>
                        <InputField
                          name="invoice_address_zip"
                          type="number"
                          maxLength={7}
                          value={newAsset.contracts[0].invoice_address_zip}
                          onChange={handleChange}
                          placeholder={t(
                            "createAsset.placeholders.zipPlaceholder"
                          )}
                          label={t("createAsset.placeholders.zipLabel")}
                          explanation={t(
                            "createAsset.placeholders.zipExplanation"
                          )}
                        />
                      </div>
                    </div>
                  </div>

                  {/* Delivery Address Section */}
                  <div className="">
                    <div className="flex flex-col gap-2">
                      <div>
                        <h5 className="text-sm font-medium  text-gray-600">
                          {t("createAsset.placeholders.deliveryAddress")}
                        </h5>

                        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-x-2 items-end">
                          {/* Checkbox column */}
                          <div className="col-span-1 sm:col-span-2 md:col-span-1 lg:col-span-1">
                            <label className="flex items-center h-10">
                              <input
                                type="checkbox"
                                name=""
                                checked={checboxValue}
                                onChange={handleCheckboxToggle}
                                className="mr-2"
                              />
                              <span className="text-sm text-gray-700">
                                {t("createAsset.placeholders.sameAsInvoice")}
                              </span>
                            </label>
                          </div>

                          {/* Street field */}
                          <div>
                            <InputField
                              name="delivery_address_street"
                              type="text"
                              maxLength={20}
                              disabled={checboxValue}
                              value={
                                checboxValue
                                  ? newAsset.contracts[0].invoice_address_street
                                  : newAsset.contracts[0]
                                      .delivery_address_street
                              }
                              onChange={handleChange}
                              placeholder={t(
                                "createAsset.placeholders.streetPlaceholder"
                              )}
                              label={t("createAsset.placeholders.streetLabel")}
                              explanation={t(
                                "createAsset.placeholders.streetExplanation"
                              )}
                            />
                          </div>

                          {/* City field */}
                          <div>
                            <InputField
                              name="delivery_address_city"
                              type="text"
                              maxLength={20}
                              disabled={checboxValue}
                              value={
                                checboxValue
                                  ? newAsset.contracts[0].invoice_address_city
                                  : newAsset.contracts[0].delivery_address_city
                              }
                              onChange={handleChange}
                              placeholder={t(
                                "createAsset.placeholders.cityPlaceholder"
                              )}
                              label={t("createAsset.placeholders.cityLabel")}
                              explanation={t(
                                "createAsset.placeholders.cityExplanation"
                              )}
                            />
                          </div>

                          {/* Country field */}
                          <div>
                            <InputField
                              name="delivery_address_country"
                              type="text"
                              maxLength={20}
                              disabled={checboxValue}
                              value={
                                checboxValue
                                  ? newAsset.contracts[0]
                                      .invoice_address_country
                                  : newAsset.contracts[0]
                                      .delivery_address_country
                              }
                              onChange={handleChange}
                              placeholder={t(
                                "createAsset.placeholders.countryPlaceholder"
                              )}
                              label={t("createAsset.placeholders.countryLabel")}
                              explanation={t(
                                "createAsset.placeholders.countryExplanation"
                              )}
                            />
                          </div>

                          {/* ZIP field */}
                          <div>
                            <InputField
                              name="delivery_address_zip"
                              type="number"
                              maxLength={7}
                              disabled={checboxValue}
                              value={
                                checboxValue
                                  ? newAsset.contracts[0].invoice_address_zip
                                  : newAsset.contracts[0].delivery_address_zip
                              }
                              onChange={handleChange}
                              placeholder={t(
                                "createAsset.placeholders.zipPlaceholder"
                              )}
                              label={t("createAsset.placeholders.zipLabel")}
                              explanation={t(
                                "createAsset.placeholders.zipExplanation"
                              )}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* History Log Section */}
                <ContractHistoryTable t={t} />
                {/* Calendar View Section */}
              </div>
            )}

            {selectedCategory === "Batteries" && (
              <div className="mb-8 ">
                <div className="mb-6 bg-white p-4 shadow-md">
                  <h4 className="text-md font-medium mb-3 text-gray-700">
                    {t("assetPageHeadings.contractInformation")}
                  </h4>

                  {/* Contract Details Row */}
                  <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-x-2 mb-2">
                    <div>
                      <SelectField
                        name="contract_type"
                        value={newAsset?.contracts[0]?.contract_type}
                        onChange={handleChange}
                        label={t("createAsset.placeholders.contractLabel")}
                        explanation={t(
                          "createAsset.placeholders.contractExplanation"
                        )}
                        required
                        menus={[
                          {
                            value: "",
                            option: t(
                              "createAsset.placeholders.contractExplanation"
                            ),
                          },
                          { value: "demo", option: t("assets.options.demo") },
                          {
                            value: "rental",
                            option: t("assets.options.rental"),
                          },
                          {
                            value: "leasing",
                            option: t("assets.options.leasing"),
                          },
                          { value: "sale", option: t("assets.options.sale") },
                          {
                            value: "maintenance",
                            option: t("assets.options.maintenance"),
                          },
                        ]}
                      />
                    </div>
                    <div>
                      <InputField
                        name="contract_start"
                        type="date"
                        value={newAsset.contracts[0].contract_start}
                        onChange={handleChange}
                        label="Start "
                        explanation={t(
                          "createAsset.placeholders.contractStartExplanation"
                        )}
                      />
                    </div>
                    <div>
                      <InputField
                        name="contract_end"
                        type="date"
                        value={newAsset.contracts[0].contract_end}
                        onChange={handleChange}
                        label="End "
                        explanation={t(
                          "createAsset.placeholders.contractEndExplanation"
                        )}
                      />
                    </div>
                    <div>
                      <InputField
                        name="contract_price_euro"
                        type="number"
                        step="0.01"
                        min="0"
                        value={newAsset.contracts[0].contract_price_euro}
                        onChange={handleChange}
                        maxLength={12}
                        label="Price"
                        placeholder={t(
                          "createAsset.placeholders.contractPricePlaceholder"
                        )}
                        explanation={t(
                          "createAsset.placeholders.contractPriceExplanation"
                        )}
                      />
                    </div>
                  </div>

                  {/* Customer Contact Information Row */}
                  <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-x-2 mb-2">
                    <div>
                      <InputField
                        name="customer_company"
                        type="text"
                        required
                        maxLength={50}
                        value={newAsset.contracts[0].customer.customer_company}
                        onChange={handleChange}
                        placeholder={t(
                          "createAsset.placeholders.companyPlaceholder"
                        )}
                        label={t("createAsset.placeholders.companyLabel")}
                        explanation={t(
                          "createAsset.placeholders.companyExplanation"
                        )}
                      />
                    </div>
                    <div>
                      <InputField
                        name="name"
                        required
                        type="text"
                        maxLength={50}
                        value={newAsset.contracts[0].customer.name}
                        onChange={handleChange}
                        placeholder={t(
                          "createAsset.placeholders.contactPersonPlaceholder"
                        )}
                        label={t("createAsset.placeholders.contactPersonLabel")}
                        explanation={t(
                          "createAsset.placeholders.contactPersonExplanation"
                        )}
                      />
                    </div>
                    <div>
                      <InputField
                        name="phone_number"
                        required
                        type="tel"
                        maxLength={20}
                        value={newAsset.contracts[0].customer.phone_number}
                        onChange={handleChange}
                        placeholder={t(
                          "createAsset.placeholders.phonePlaceholder"
                        )}
                        label={t("createAsset.placeholders.phoneLabel")}
                        explanation={t(
                          "createAsset.placeholders.phoneExplanation"
                        )}
                      />
                    </div>
                    <div>
                      <InputField
                        name="email"
                        type="email"
                        maxLength={100}
                        value={newAsset.contracts[0].customer.email}
                        onChange={handleChange}
                        placeholder={t(
                          "createAsset.placeholders.emailPlaceholder"
                        )}
                        label={t("createAsset.placeholders.emailLabel")}
                        explanation={t(
                          "createAsset.placeholders.emailExplanation"
                        )}
                      />
                    </div>
                    <div>
                      <InputField
                        name="customer_number"
                        type="text"
                        maxLength={20}
                        value={newAsset.contracts[0].customer.customer_number}
                        onChange={handleChange}
                        placeholder={t(
                          "createAsset.placeholders.customerNumberPlaceholder"
                        )}
                        label={t(
                          "createAsset.placeholders.customerNumberLabel"
                        )}
                        explanation={t(
                          "createAsset.placeholders.customerNumberExplanation"
                        )}
                      />
                    </div>
                  </div>

                  {/* Invoice Address Section */}
                  <div className="mb-4">
                    <h5 className="text-sm font-medium mb-2 text-gray-600">
                      {t("createAsset.placeholders.InvoiceAddress")}
                    </h5>
                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-6 gap-x-2">
                      {Array.isArray(warehouses) && warehouses?.length > 0 && (
                        <div className="col-span-2">
                          <SelectField
                            name="warehouse"
                            value={selectedContractWarehouse?.id || ""}
                            onChange={(e) => {
                              handleWarehouseChange2(e);
                            }}
                            label={t("createAsset.placeholders.warehouseLabel")}
                            explanation={t(
                              "createAsset.placeholders.warehouseExplanation"
                            )}
                            placeholder={t(
                              "createAsset.placeholders.warehousePlaceholder"
                            )}
                            menus={[
                              {
                                value: "",
                                option: t(
                                  "createAsset.placeholders.warehousePlaceholder"
                                ),
                              },
                              ...warehouses.map((warehouse) => {
                                return {
                                  value: warehouse.id,
                                  option: warehouse.name,
                                };
                              }),
                            ]}
                          />
                        </div>
                      )}
                      <div>
                        <InputField
                          name="invoice_address_street"
                          type="text"
                          maxLength={20}
                          value={newAsset.contracts[0].invoice_address_street}
                          onChange={handleChange}
                          placeholder={t(
                            "createAsset.placeholders.streetPlaceholder"
                          )}
                          label={t("createAsset.placeholders.streetLabel")}
                          explanation={t(
                            "createAsset.placeholders.streetExplanation"
                          )}
                        />
                      </div>

                      <div>
                        <InputField
                          name="invoice_address_city"
                          type="text"
                          maxLength={20}
                          // newAsset.contracts[0].contract_start
                          value={newAsset.contracts[0].invoice_address_city}
                          onChange={handleChange}
                          placeholder={t(
                            "createAsset.placeholders.cityPlaceholder"
                          )}
                          label={t("createAsset.placeholders.cityLabel")}
                          explanation={t(
                            "createAsset.placeholders.cityExplanation"
                          )}
                        />
                      </div>
                      <div>
                        <InputField
                          name="invoice_address_country"
                          type="text"
                          maxLength={20}
                          value={newAsset.contracts[0].invoice_address_country}
                          onChange={handleChange}
                          placeholder={t(
                            "createAsset.placeholders.countryPlaceholder"
                          )}
                          label={t("createAsset.placeholders.countryLabel")}
                          explanation={t(
                            "createAsset.placeholders.countryExplanation"
                          )}
                        />
                      </div>

                      <div>
                        <InputField
                          name="invoice_address_zip"
                          type="text"
                          maxLength={7}
                          value={newAsset.contracts[0].invoice_address_zip}
                          onChange={handleChange}
                          placeholder={t(
                            "createAsset.placeholders.zipPlaceholder"
                          )}
                          label={t("createAsset.placeholders.zipLabel")}
                          explanation={t(
                            "createAsset.placeholders.zipExplanation"
                          )}
                        />
                      </div>
                    </div>
                  </div>

                  {/* Delivery Address Section */}
                  <div className="">
                    <div className="flex flex-col gap-2">
                      <div>
                        <h5 className="text-sm font-medium  text-gray-600">
                          {t("createAsset.placeholders.deliveryAddress")}
                        </h5>

                        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-6 gap-x-2 items-end">
                          {/* Checkbox column */}
                          <div className="lg:col-span-1">
                            <label className="flex items-center h-10">
                              <input
                                type="checkbox"
                                name=""
                                checked={checboxValue}
                                onChange={handleCheckboxToggle}
                                className="mr-2"
                              />
                              <span className="text-sm text-gray-700">
                                {t("createAsset.placeholders.sameAsInvoice")}
                              </span>
                            </label>
                          </div>

                          {/* Street field */}
                          <div>
                            <InputField
                              name="delivery_address_street"
                              type="text"
                              maxLength={20}
                              disabled={checboxValue}
                              value={
                                checboxValue
                                  ? newAsset.contracts[0].invoice_address_street
                                  : newAsset.contracts[0]
                                      .delivery_address_street
                              }
                              onChange={handleChange}
                              placeholder={t(
                                "createAsset.placeholders.streetPlaceholder"
                              )}
                              label={t("createAsset.placeholders.streetLabel")}
                              explanation={t(
                                "createAsset.placeholders.streetExplanation"
                              )}
                            />
                          </div>

                          {/* City field */}
                          <div>
                            <InputField
                              name="delivery_address_city"
                              type="text"
                              maxLength={20}
                              disabled={checboxValue}
                              value={
                                checboxValue
                                  ? newAsset.contracts[0].invoice_address_city
                                  : newAsset.contracts[0].delivery_address_city
                              }
                              onChange={handleChange}
                              placeholder={t(
                                "createAsset.placeholders.cityPlaceholder"
                              )}
                              label={t("createAsset.placeholders.cityLabel")}
                              explanation={t(
                                "createAsset.placeholders.cityExplanation"
                              )}
                            />
                          </div>

                          {/* Country field */}
                          <div>
                            <InputField
                              name="delivery_address_country"
                              type="text"
                              maxLength={20}
                              disabled={checboxValue}
                              value={
                                checboxValue
                                  ? newAsset.contracts[0]
                                      .invoice_address_country
                                  : newAsset.contracts[0]
                                      .delivery_address_country
                              }
                              onChange={handleChange}
                              placeholder={t(
                                "createAsset.placeholders.countryPlaceholder"
                              )}
                              label={t("createAsset.placeholders.countryLabel")}
                              explanation={t(
                                "createAsset.placeholders.countryExplanation"
                              )}
                            />
                          </div>

                          {/* ZIP field */}
                          <div>
                            <InputField
                              name="delivery_address_zip"
                              type="text"
                              maxLength={7}
                              disabled={checboxValue}
                              value={
                                checboxValue
                                  ? newAsset.contracts[0].invoice_address_zip
                                  : newAsset.contracts[0].delivery_address_zip
                              }
                              onChange={handleChange}
                              placeholder={t(
                                "createAsset.placeholders.zipPlaceholder"
                              )}
                              label={t("createAsset.placeholders.zipLabel")}
                              explanation={t(
                                "createAsset.placeholders.zipExplanation"
                              )}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <ContractHistoryTable t={t} />
              </div>
            )}
            {selectedCategory === "Attachments" && (
              <ContractInfoSection
                t={t}
                newAsset={newAsset}
                handleChange={handleChange}
                warehouses={warehouses}
                selectedContractWarehouse={selectedContractWarehouse}
                handleWarehouseChange2={handleWarehouseChange2}
                checboxValue={checboxValue}
                handleCheckboxToggle={handleCheckboxToggle}
              />
            )}
            {selectedCategory === "Lift Masts" && (
              <ContractInfoSection
                t={t}
                newAsset={newAsset}
                handleChange={handleChange}
                warehouses={warehouses}
                selectedContractWarehouse={selectedContractWarehouse}
                handleWarehouseChange2={handleWarehouseChange2}
                checboxValue={checboxValue}
                handleCheckboxToggle={handleCheckboxToggle}
              />
            )}
            {selectedCategory === "Work Platforms" && (
              <ContractInfoSection
                t={t}
                newAsset={newAsset}
                handleChange={handleChange}
                warehouses={warehouses}
                selectedContractWarehouse={selectedContractWarehouse}
                handleWarehouseChange2={handleWarehouseChange2}
                checboxValue={checboxValue}
                handleCheckboxToggle={handleCheckboxToggle}
              />
            )}
            {selectedCategory === "Cleaning Equipment" && (
              <ContractInfoSection
                t={t}
                newAsset={newAsset}
                handleChange={handleChange}
                warehouses={warehouses}
                selectedContractWarehouse={selectedContractWarehouse}
                handleWarehouseChange2={handleWarehouseChange2}
                checboxValue={checboxValue}
                handleCheckboxToggle={handleCheckboxToggle}
              />
            )}
            {selectedCategory === "Spare Parts" && (
              <ContractInfoSection
                t={t}
                newAsset={newAsset}
                handleChange={handleChange}
                warehouses={warehouses}
                selectedContractWarehouse={selectedContractWarehouse}
                handleWarehouseChange2={handleWarehouseChange2}
                checboxValue={checboxValue}
                handleCheckboxToggle={handleCheckboxToggle}
              />
            )}
            {selectedCategory === "Construction Machinery" && (
              <ContractInfoSection
                t={t}
                newAsset={newAsset}
                handleChange={handleChange}
                warehouses={warehouses}
                selectedContractWarehouse={selectedContractWarehouse}
                handleWarehouseChange2={handleWarehouseChange2}
                checboxValue={checboxValue}
                handleCheckboxToggle={handleCheckboxToggle}
              />
            )}
          </>
        )}
        <div className="flex flex-wrap gap-2 sm:gap-3 justify-center sm:justify-start items-center my-4">
          {currentStep < steps.length - 1 && (
            <>
              {currentStep !== 0 ? (
                <button
                  variant="primary"
                  onClick={() => navigate("/dashboard")}
                  disabled={currentStep === 0}
                  type="button"
                  className="bg-gray-200  text-black px-4 py-2 -md text-sm sm:text-base w-full sm:w-auto"
                >
                  {t("common.cancel")}
                </button>
              ) : (
                <button
                  type="button"
                  variant="close"
                  onClick={() => navigate("/dashboard")}
                  className="bg-gray-200  text-black px-4 py-2 -md text-sm sm:text-base w-full sm:w-auto"
                >
                  {/* {t("warehouse.cancelButton")} */}
                  {t("common.cancel")}
                </button>
              )}

              <button
                variant="primary"
                type="submit"
                // onClick={handleNextStep}
                className={`bg-blue-600 hover:bg-blue-700 text-white px-4 py-2  text-sm sm:text-base w-full sm:w-auto ${
                  isLoading ? "opacity-50 cursor-not-allowed" : ""
                }`}
                disabled={isLoading}
              >
                {t("common.buttons.save")}
              </button>
            </>
          )}

          {currentStep === steps.length - 1 && (
            <>
              <button
                variant="primary"
                type="button"
                onClick={() => navigate("/dashboard")}
                disabled={currentStep === 0}
                className="bg-gray-200  text-black px-4 py-2 -md text-sm sm:text-base w-full sm:w-auto"
              >
                {t("common.cancel")}
              </button>

              <button
                variant="primary"
                type="submit"
                className={`bg-blue-600 hover:bg-blue-700 text-white px-4 py-2  text-sm sm:text-base w-full sm:w-auto ${
                  isLoading ? "opacity-50 cursor-not-allowed" : ""
                }`}
                disabled={isLoading}
              >
                {t("common.buttons.save")}
              </button>
            </>
          )}
        </div>
      </form>
    </div>
  );
};

export default CreateAssetPage;
